import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useLocation, Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ButtonGroup, Image, Spinner, Modal, Alert, Card, Nav, Breadcrumb, OverlayTrigger, Tooltip, Carousel, FormCheck, Toast, ToastContainer} from 'react-bootstrap';
import MainNav from '../components/MainNav';
import SignInModal from '../components/SignInModal';
import ShareModal from '../components/ShareModal';
import ValueDisplayGroup from '../components/ValueDisplayGroup';
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    ResponsiveContainer,
} from 'recharts';
import { APIProvider, Map, AdvancedMarker, InfoWindow, useAdvancedMarkerRef, Pin } from '@vis.gl/react-google-maps';
import './Styles.css';
import { FaCheckCircle, FaExternalLinkAlt, FaTimesCircle, FaInfoCircle, FaStar, FaSave, FaQuestionCircle, FaShareAlt, FaMinus, FaPlus, FaBed, FaBath, FaCar, FaArrowUp, FaArrowDown,FaChartLine, FaBalanceScale, FaHistory, FaCheck, FaSearch, FaUserCircle, FaTrash, FaPencilAlt, FaMapMarkerAlt, FaRulerCombined, FaCalendarAlt, FaChevronLeft, FaChevronRight, FaHome, FaThumbsUp, FaExclamationTriangle, FaRoute, FaSchool, FaShoppingCart, FaTree, FaEnvelope, FaTimes, FaBell, FaBellSlash, FaBan, FaUndo, FaPhone, FaListUl, FaMap } from 'react-icons/fa';
import { handleTokenAndPostRequest, formatCurrency, setMetaTags, trackEvent } from '../utils/utils';
import { useAgentDetails } from '../utils/useAgentDetails';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import makeAnimated from 'react-select/animated';
import { set } from 'lodash';

import EditableList from '../components/EditableList';
import ImageUploadButton from '../components/ImageUploadButton';

import RequestAppraisalModal from '../components/RequestAppraisalModal';
import EnquiryModal from '../components/EnquiryModal';
import AppraisalMap from '../components/AppraisalMap';
import ValuationFeedbackModal from '../components/ValuationFeedbackModal';
import TrackPropertyModal from '../components/TrackPropertyModal';
import PropertyQrUnlockModal from '../components/PropertyQrUnlockModal';

const propertyTypeOptions = [
    { value: 'House', label: 'House' },
    { value: 'Apartment', label: 'Apartment' },
    { value: 'Townhouse', label: 'Townhouse' },
    { value: 'Vacant Land', label: 'Vacant Land' },
    { value: 'Villa', label: 'Villa' },
    { value: 'Acreage Semi Rural', label: 'Acreage Semi Rural' },
    { value: 'Rural', label: 'Rural' },
    { value: 'Semi Detached', label: 'Semi Detached' },
    { value: 'Duplex', label: 'Duplex' },
    { value: 'New House Land', label: 'New House Land' },
    { value: 'New Apartments', label: 'New Apartments' },
    { value: 'Block Of Units', label: 'Block Of Units' },
    { value: 'Studio', label: 'Studio' },
    { value: 'Terrace', label: 'Terrace' }
];


        
const proFeatureOptions = [
    { value: 'SecureParking', label: 'Secure Parking' },
    { value: 'BuiltInWardrobes', label: 'Built In Wardrobes' },
    { value: 'AirConditioning', label: 'Air Conditioning' },
    { value: 'Ensuite', label: 'Ensuite' },
    { value: 'Gas', label: 'Gas' },
    { value: 'Heating', label: 'Heating' },
    { value: 'Dishwasher', label: 'Dishwasher' },
    { value: 'Floorboards', label: 'Floorboards' },
    { value: 'Study', label: 'Study' },
    { value: 'SwimmingPool', label: 'Swimming Pool' },
    { value: 'Bath', label: 'Bath' },
    { value: 'InternalLaundry', label: 'Internal Laundry' },
    { value: 'Shed', label: 'Shed' },
    { value: 'Intercom', label: 'Intercom' },
    { value: 'FullyFenced', label: 'Fully Fenced' },
    { value: 'NorthFacing', label: 'North Facing' },
    { value: 'SolarPanels', label: 'Solar Panels' },
    { value: 'GroundFloor', label: 'Ground Floor' },
    { value: 'AlarmSystem', label: 'Alarm System' },
    { value: 'Gym', label: 'Gym' },
    { value: 'BalconyDeck', label: 'Balcony Deck' },
    { value: 'PetsAllowed', label: 'Pets Allowed' },
    { value: 'GardenCourtyard', label: 'Garden Courtyard' },
    { value: 'WaterViews', label: 'Water Views' },
    { value: 'Furnished', label: 'Furnished' },
    { value: 'CityViews', label: 'City Views' },
    { value: 'SeparateDiningRoom', label: 'Separate Dining Room' },
    { value: 'RainwaterStorageTank', label: 'Rainwater Storage Tank' },
    { value: 'BroadbandInternetAccess', label: 'Broadband Internet Access' },
    { value: 'CableOrSatellite', label: 'Cable Or Satellite' },
    { value: 'TennisCourt', label: 'Tennis Court' },
    { value: 'SolarHotWater', label: 'Solar Hot Water' },
    { value: 'DoubleGlazedWindows', label: 'Double Glazed Windows' },
    { value: 'WallCeilingInsulation', label: 'Wall Ceiling Insulation' },
    { value: 'OutdoorSpa', label: 'Outdoor Spa' },
    { value: 'IndoorSpa', label: 'Indoor Spa' },
    { value: 'EnergyEfficientAppliances', label: 'Energy Efficient Appliances' },
    { value: 'WaterEfficientAppliances', label: 'Water Efficient Appliances' },
    { value: 'GreywaterSystem', label: 'Greywater System' },
    { value: 'WaterEfficientFixtures', label: 'Water Efficient Fixtures' },

    // AI Generated Features
    { value: 'SmartHomeTechnology', label: 'Smart Home Technology' },
    { value: 'HomeOffice', label: 'Home Office' },
    { value: 'WineCellar', label: 'Wine Cellar' },
    { value: 'HomeTheater', label: 'Home Theater' },
    { value: 'RooftopTerrace', label: 'Rooftop Terrace' },
    { value: 'PrivateElevator', label: 'Private Elevator' },
    { value: 'ButlersPantry', label: 'Butler\'s Pantry' },
    { value: 'Library', label: 'Library' },
    { value: 'Fireplace', label: 'Fireplace' },
    { value: 'Mudroom', label: 'Mudroom' },
    { value: 'WalkInPantry', label: 'Walk-In Pantry' },
    { value: 'OutdoorKitchen', label: 'Outdoor Kitchen' }
];
    

const conFeatureOptions = [
    { value: 'HighMaintenance', label: 'High Maintenance' },
    { value: 'NoisyNeighborhood', label: 'Noisy Neighborhood' },
    { value: 'PoorPublicTransport', label: 'Poor Public Transport' },
    { value: 'LimitedParking', label: 'Limited Parking' },
    { value: 'OldAppliances', label: 'Old Appliances' },
    { value: 'SmallRooms', label: 'Small Rooms' },
    { value: 'NoOutdoorSpace', label: 'No Outdoor Space' },
    { value: 'HighCrimeRate', label: 'High Crime Rate' },
    { value: 'FloodProneArea', label: 'Flood Prone Area' },
    { value: 'ExpensiveUtilities', label: 'Expensive Utilities' },
    { value: 'PoorInsulation', label: 'Poor Insulation' },
    { value: 'NoisyNeighbors', label: 'Noisy Neighbors' },
    { value: 'LimitedNaturalLight', label: 'Limited Natural Light' },
    { value: 'FarFromAmenities', label: 'Far From Amenities' },
    { value: 'OldRoof', label: 'Old Roof' },
    { value: 'FoundationIssues', label: 'Foundation Issues' },
    { value: 'PestProblems', label: 'Pest Problems' },
    { value: 'NoGarage', label: 'No Garage' },
    { value: 'SteepDriveway', label: 'Steep Driveway' },
    { value: 'PoorSchoolDistrict', label: 'Poor School District' },
    { value: 'LimitedStorage', label: 'Limited Storage' },
    { value: 'OutdatedInterior', label: 'Outdated Interior' },
    { value: 'NoAirConditioning', label: 'No Air Conditioning' },
    { value: 'NoHeating', label: 'No Heating' },
    { value: 'SharedWalls', label: 'Shared Walls' },
    { value: 'NoPrivacy', label: 'No Privacy' },
    { value: 'LimitedInternetOptions', label: 'Limited Internet Options' }
];

const analysisSteps = [
    'Collecting comparable sales data',
    'Analysing property features',
    'Running valuation model',
    'Generating valuation trend chart',
    'Estimating days to sell',
    'Estimating rental value',
    'Generating rental trend chart',
    'Writing AI sales market summary',
    'Writing AI rental market summary',
];

const estimateSectionSteps = [
    'Collecting property data',
    'Reviewing comparable sales',
    'Calibrating valuation model',
    'Building estimate trend',
    'Refining sale estimate',
    'Refining rental estimate',
    'Checking estimate confidence',
    'Preparing value summary',
    'Finalising estimate results',
];

const structuredSteps = [
    'Estimating sale price',
    'Estimating rental price',
    'Estimating days to sell',
];

const estimateStructuredSteps = [
    'Estimating property value',
    'Generating estimate trend',
    'Finalising estimate results',
];

const daysOnMarketStructuredSteps = [
    'Estimating days on market',
    'Analysing suburb selling pace',
    'Finalising days on market trend',
];

// Carousel for a comparable's photos shown when its card is expanded.
// Images are only fetched on demand: the first slide loads when the card is
// opened, and each subsequent slide loads only once the user navigates to it.
const ComparableImageCarousel = ({ images, alt, isMobile }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [loaded, setLoaded] = useState(() => new Set([0]));
    const height = isMobile ? 180 : 240;

    if (!images || images.length === 0) return null;

    if (images.length === 1) {
        return (
            <img src={images[0]} alt={alt} loading="lazy"
                style={{ width: '100%', height, objectFit: 'cover', borderRadius: 10, marginBottom: 10 }}
                onError={e => { e.target.style.display = 'none'; }} />
        );
    }

    const handleSelect = (idx) => {
        setActiveIndex(idx);
        setLoaded(prev => { if (prev.has(idx)) return prev; const next = new Set(prev); next.add(idx); return next; });
    };

    return (
        <div style={{ borderRadius: 10, overflow: 'hidden', marginBottom: 10 }}>
            <Carousel activeIndex={activeIndex} onSelect={handleSelect} interval={null} wrap={false} indicators={images.length <= 8} controls>
                {images.map((url, idx) => (
                    <Carousel.Item key={idx}>
                        {loaded.has(idx) ? (
                            <img src={url} alt={`${alt} ${idx + 1}`} loading="lazy"
                                style={{ width: '100%', height, objectFit: 'cover', display: 'block' }}
                                onError={e => { e.target.style.visibility = 'hidden'; }} />
                        ) : (
                            <div style={{ width: '100%', height, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
                                <Spinner animation="border" size="sm" style={{ color: '#9ca3af' }} />
                            </div>
                        )}
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};

// List ⇄ Map segmented toggle for a comparables section. Both views read the
// same already-loaded comps, so flipping never refetches.
const CompViewToggle = ({ view, onChange, accentColor, buttonTextColor }) => (
    <div role="tablist" aria-label="Comparables view" style={{ display: 'inline-flex', gap: 4, padding: 4, background: '#f3f4f6', borderRadius: 999, marginBottom: 16 }}>
        {[{ key: 'list', label: 'List', Icon: FaListUl }, { key: 'map', label: 'Map', Icon: FaMap }].map(({ key, label, Icon }) => {
            const active = view === key;
            return (
                <button
                    key={key}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    onClick={() => onChange(key)}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6, border: 'none', cursor: 'pointer',
                        background: active ? accentColor : 'transparent',
                        color: active ? (buttonTextColor || '#fff') : '#6b7280',
                        padding: '6px 16px', borderRadius: 999, fontSize: '0.78rem', fontWeight: 600,
                        transition: 'background 0.15s, color 0.15s',
                    }}
                >
                    <Icon size={11} /> {label}
                </button>
            );
        })}
    </div>
);

const PropertyProfile = () => {
    const [propertyData, setPropertyData] = useState(null);
    const [propertyAnalysisData, setPropertyAnalysisData] = useState(null);
    useEffect(() => { propertyAnalysisDataRef.current = propertyAnalysisData; }, [propertyAnalysisData]);
    const { property } = useParams();
    const { agent_slug, agentDetails, setAgentDetails, branding } = useAgentDetails();

    // ── QR-code unlock gate ─────────────────────────────────────────────
    // Anyone who lands on this page directly from a printed per-property QR
    // card has `?campaign=qr_code_property` in the URL. We block them with a
    // full-screen modal until they hand over a mobile number — the SMS we
    // send back contains `?t=<token>` which resolves to a DIFFERENT campaign
    // (`qr_code_property_sms_link`), so the modal never re-shows when they
    // tap the link from their messages.
    const _ppLocation = useLocation();
    const qrCampaign = (new URLSearchParams(_ppLocation.search).get('campaign') || '').toLowerCase();
    // `preview` is the campaign the agent app uses when generating preview
    // QR thumbnails; we treat it the same as a real QR scan so you can sanity-
    // check the gate from the design picker without printing anything.
    const showQrUnlockModal = qrCampaign === 'qr_code_property' || qrCampaign === 'preview';

    const [propertyId, setPropertyId] = useState(property.split('-').pop())

    console.log('propertyId:', propertyId);
    console.log('property.split().pop()', property.split('-').pop())
    const [suburb, setSuburb] = useState(null);
    const [postcode, setPostcode] = useState(null);
    const [bedrooms, setBedrooms] = useState(null);
    const [bathrooms, setBathrooms] = useState(null);
    const [carspaces, setCarspaces] = useState(null);    
    const [propertyType, setPropertyType] = useState(propertyTypeOptions[0]);
    const [landArea, setLandArea] = useState(null);
    const [propertyNotes, setPropertyNotes] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [state, setState] = useState(null);
    const [mediaUrls, setMediaUrls] = useState([]);
    const [analysedBedrooms, setAnalysedBedrooms] = useState(null);
    const [analysedProFeatures, setAnalysedProFeatures] = useState([]);
    const [analysedConFeatures, setAnalysedConFeatures] = useState([]);
    const [analysedBathrooms, setAnalysedBathrooms] = useState(null);
    const [analysedCarspaces, setAnalysedCarspaces] = useState(null);    
    const [analysedPropertyType, setAnalysedPropertyType] = useState(propertyTypeOptions[0]);
    const [analysedLandArea, setAnalysedLandArea] = useState(null);
    const [analysedMediaUrls, setAnalysedMediaUrls] = useState([]);
    const [analysedPropertyNotes, setAnalysedPropertyNotes] = useState(null);
    const [analysedUserNotes, setAnalysedUserNotes] = useState([]);

    const [savedBedrooms, setSavedBedrooms] = useState(null);
    const [savedBathrooms, setSavedBathrooms] = useState(null);
    const [savedCarspaces, setSavedCarspaces] = useState(null);    
    const [savedPropertyType, setSavedPropertyType] = useState(propertyTypeOptions[0]);
    const [savedLandArea, setSavedLandArea] = useState(null);
    const [savedProFeatures, setSavedProFeatures] = useState([]);
    const [savedConFeatures, setSavedConFeatures] = useState([]);
    const [savedMediaUrls, setSavedMediaUrls] = useState([]);
    const [savedUploadedImageUrls, setSavedUploadedImageUrls] = useState([]);
    const [savedPropertyNotes, setSavedPropertyNotes] = useState(null);

    const [analysisNeeded, setAnalysisNeeded] = useState(false);
    // While the QR unlock gate is up, suppress any modal that defaults to
    // open on mount — Bootstrap's <Modal> manages document.activeElement and
    // would otherwise steal focus from the gate's mobile-number input.
    const [showAlert, setShowAlert] = useState(!showQrUnlockModal);
    const [proFeatures, setProFeatures] = useState([]);
    const [conFeatures, setConFeatures] = useState([]);
    const [activeSection, setActiveSection] = useState('sale-estimate');
    const [analysisLoading, setAnalysisLoading] = useState(false);
    const [propertyLoading, setPropertyLoading] = useState(false);
    const [propertyError, setPropertyError] = useState(null);
    const [recentSoldData, setRecentSoldData] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);
    const [modalShow, setModalShow] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [shareUrl, setShareUrl] = useState(null);
    
    const [showSaveToast, setShowSaveToast] = useState(false);
    const [isSaved, setIsSaved] = useState(false);    
    const [estimationInfoShowModal, setEstimationInfoShowModal] = useState(!showQrUnlockModal);

    const [showShareModal, setShowShareModal] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);

    const [agentNotes, setAgentNotes] = useState([]);
    const [showRequestReviewModal, setShowRequestReviewModal] = useState(false);

    const [userNotes, setUserNotes] = useState([]);
    const [newUserNote, setNewUserNote] = useState('');
    const [isSavingUserNote, setIsSavingUserNote] = useState(false);
    const [deletingNoteId, setDeletingNoteId] = useState(null);
    const [notesTabKey, setNotesTabKey] = useState('your-notes');
    const [showMoreNoteOptions, setShowMoreNoteOptions] = useState(false);
    const [showAllUserNotes, setShowAllUserNotes] = useState(false);
    const [showValuationFeedbackModal, setShowValuationFeedbackModal] = useState(false);
    const [showAllAgentNotes, setShowAllAgentNotes] = useState(false);
    const [isPropertyTracked, setIsPropertyTracked] = useState(false);
    const [isTogglingTrack, setIsTogglingTrack] = useState(false);
    const [showTrackToast, setShowTrackToast] = useState(false);
    const [trackToastMessage, setTrackToastMessage] = useState('');
    const [showTrackPublicModal, setShowTrackPublicModal] = useState(false);
    const [isSendingShare, setIsSendingShare] = useState(false);
    const [showEditModal, setShowEditModal] = useState(!showQrUnlockModal);
    const [showEditExtras, setShowEditExtras] = useState(false);
    // First time the user opens the review-attributes (edit) modal in a session
    // we hide the "edit description & images" toggle to keep things simple.
    const [isFirstReviewView] = useState(() => sessionStorage.getItem('reviewAttributesSeen') !== 'true');
    // Whether the full list of sale/rent comparables is expanded (default shows first 4).
    const [showAllSaleComps, setShowAllSaleComps] = useState(false);
    const [showAllRentComps, setShowAllRentComps] = useState(false);
    // List vs Map view for each comparables section. Both views share the loaded
    // comps, so flipping never refetches.
    const [soldCompView, setSoldCompView] = useState('list');
    const [rentCompView, setRentCompView] = useState('list');
    const [onMarketView, setOnMarketView] = useState('list');
    // Tracks whether the agent phone number has been revealed in each estimate panel.
    const [phoneRevealed, setPhoneRevealed] = useState({ sale: false, rent: false });
    const [expandedCompId, setExpandedCompId] = useState(null);
    const [numComparables, setNumComparables] = useState(4);
    const [analysisType, setAnalysisType] = useState({ sale: true, rental: true });
    const [analysedNumComparables, setAnalysedNumComparables] = useState(4);
    const [analysedAnalysisType, setAnalysedAnalysisType] = useState({ sale: true, rental: true });
    const [modalStep, setModalStep] = useState(() => sessionStorage.getItem('valuationToolModalSeen') ? 'edit' : 'info'); // 'info' or 'edit'
    const [analysisStep, setAnalysisStep] = useState(0);
    const [streamingAiSummary, setStreamingAiSummary] = useState('');
    const [isStreaming, setIsStreaming] = useState(false);
    const [structuredLoading, setStructuredLoading] = useState(false);
    const [structuredStep, setStructuredStep] = useState(0);
    const userNoteRef = useRef(null);
    const moreOptionsRef = useRef(null);
    const streamingAiSummaryRef = useRef('');
    const streamingContainerRef = useRef(null);
    const estimatesAreaRef = useRef(null);
    const [streamingProgress, setStreamingProgress] = useState(0);
    const analysisAbortRef = useRef(null);
    const [hasStartedWriting, setHasStartedWriting] = useState(false);
    const [comparableCards, setComparableCards] = useState([]);
    const [comparableResults, setComparableResults] = useState({});
    const [comparableLoading, setComparableLoading] = useState({});
    // "What's on the market now" — currently-live nearby listings, fetched
    // independently of the AI analysis (see the /on-market-listings effect).
    const [onMarketListings, setOnMarketListings] = useState([]);
    const [onMarketLoading, setOnMarketLoading] = useState(false);
    const [showAllOnMarket, setShowAllOnMarket] = useState(false);
    const [selectingComparables, setSelectingComparables] = useState(false);
    // Comparables the user has excluded from the estimate (keyed by comp id)
    const [excludedCompIds, setExcludedCompIds] = useState(() => new Set());
    // Tracks which estimate is being re-calculated after an exclusion change
    const [recalcEstimate, setRecalcEstimate] = useState({ sale: false, rent: false });
    // Holds the inputs from the last analysis so estimates can be re-calculated on exclusion
    const analysisContextRef = useRef(null);
    // Mirror of propertyAnalysisData for synchronous reads during recalculation
    const propertyAnalysisDataRef = useRef(null);
    const [locationAnalysis, setLocationAnalysis] = useState(null);
    const [locationLoading, setLocationLoading] = useState(false);
    const [locationMapUrl, setLocationMapUrl] = useState('');
    const [showRequestAppraisalModal, setShowRequestAppraisalModal] = useState(false);
    const [showEnquiryFromBar, setShowEnquiryFromBar] = useState(false);

    // Belt-and-braces: while the QR gate is up, any Bootstrap modal that
    // sneaks open (e.g. the scroll-triggered TrackPropertyModal that fires
    // when the iOS virtual keyboard reflows the viewport) immediately steals
    // focus from the gate's input. Force them all back to closed every render
    // so the agent's recipient can actually type their mobile number on mobile.
    useEffect(() => {
        if (!showQrUnlockModal) return;
        if (showTrackPublicModal) setShowTrackPublicModal(false);
        if (showRequestAppraisalModal) setShowRequestAppraisalModal(false);
        if (showEnquiryFromBar) setShowEnquiryFromBar(false);
        if (showValuationFeedbackModal) setShowValuationFeedbackModal(false);
        if (showShareModal) setShowShareModal(false);
        if (modalShow) setModalShow(false);
        if (showEditModal) setShowEditModal(false);
        if (estimationInfoShowModal) setEstimationInfoShowModal(false);
    }, [
        showQrUnlockModal,
        showTrackPublicModal, showRequestAppraisalModal, showEnquiryFromBar,
        showValuationFeedbackModal, showShareModal, modalShow,
        showEditModal, estimationInfoShowModal,
    ]);

    const comparablesRef = useRef(null);
    const valuationRef = useRef(null);
    const daysToSellRef = useRef(null);
    const saleComparablesRef = useRef(null);
    const saleEstimateRef = useRef(null);
    const saleDaysRef = useRef(null);
    const rentComparablesRef = useRef(null);
    const rentEstimateRef = useRef(null);
    const rentDaysRef = useRef(null);
    const onMarketRef = useRef(null);
    const locationRef = useRef(null);
    const historyRef = useRef(null);
    const sectionRefs = useRef({ 'sale-estimate': saleEstimateRef, 'sale-comparables': saleComparablesRef, 'sale-days': saleDaysRef, 'rent-estimate': rentEstimateRef, 'rent-comparables': rentComparablesRef, 'rent-days': rentDaysRef, 'on-market': onMarketRef, location: locationRef, history: historyRef });
    const isScrollingRef = useRef(false);
    const stickyBarRef = useRef(null);
    const activeSectionRef = useRef('sale-estimate');
    const stickyTabsRowRef = useRef(null);
    const stickyTabButtonRefs = useRef({});

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (moreOptionsRef.current && !moreOptionsRef.current.contains(e.target)) {
                setShowMoreNoteOptions(false);
            }
        };
        if (showMoreNoteOptions) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showMoreNoteOptions]);

    // Scroll-based section tracking
    const handleSectionClick = useCallback((key) => {
        activeSectionRef.current = key;
        setActiveSection(key);
        const ref = sectionRefs.current[key];
        if (ref?.current) {
            isScrollingRef.current = true;
            const barH = stickyBarRef.current?.offsetHeight || 0;
            const y = ref.current.getBoundingClientRect().top + window.scrollY - barH - 8;
            window.scrollTo({ top: y, behavior: 'smooth' });
            setTimeout(() => { isScrollingRef.current = false; }, 800);
        }
    }, []);

    const rentEstimateModalFiredRef = useRef(false);
    useEffect(() => {
        const sectionKeys = ['sale-estimate', 'sale-comparables', 'sale-days', 'rent-estimate', 'rent-comparables', 'rent-days', 'on-market', 'location', 'history'];
        const refs = sectionRefs.current;
        let ticking = false;
        const onScroll = () => {
            if (isScrollingRef.current) return;
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                const viewportBottom = window.innerHeight;
                let active = sectionKeys[0];
                for (const key of sectionKeys) {
                    const el = refs[key]?.current;
                    if (el && el.getBoundingClientRect().top <= viewportBottom) active = key;
                }
                if (active !== activeSectionRef.current) {
                    activeSectionRef.current = active;
                    setActiveSection(active);
                }
                // Trigger track-property modal once when rent-estimate scrolls into view (public visitors only)
                // Skipped while the QR unlock gate is up — on mobile the
                // virtual keyboard reflows the viewport and fires scroll
                // events here, which would otherwise pop this modal and
                // steal focus from the gate's mobile-number input.
                if (!rentEstimateModalFiredRef.current && !showQrUnlockModal) {
                    const rentEl = refs['rent-estimate']?.current;
                    if (rentEl && rentEl.getBoundingClientRect().top <= viewportBottom * 0.85) {
                        rentEstimateModalFiredRef.current = true;
                        const jwt_token = localStorage.getItem('jwt_token');
                        const param_token = localStorage.getItem('param_token');
                        if (!jwt_token && !param_token) {
                            trackEvent('modal_open_track_property_public', { trigger: 'scroll_rent_estimate', property_id: propertyId });
                            setShowTrackPublicModal(true);
                        }
                    }
                }
                ticking = false;
            });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [propertyId, showQrUnlockModal]);

    useEffect(() => {
        if (!isMobile) return;
        const rowEl = stickyTabsRowRef.current;
        const tabEl = stickyTabButtonRefs.current[activeSection];
        if (!rowEl || !tabEl) return;

        const rowRect = rowEl.getBoundingClientRect();
        const tabRect = tabEl.getBoundingClientRect();
        const isOverflowingLeft = tabRect.left < rowRect.left + 8;
        const isOverflowingRight = tabRect.right > rowRect.right - 8;

        if (isOverflowingLeft || isOverflowingRight) {
            tabEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [activeSection, isMobile]);

    useEffect(() => {
        if (userNoteRef.current) {
            userNoteRef.current.style.height = 'auto';
            userNoteRef.current.style.height = userNoteRef.current.scrollHeight + 'px';
        }
    }, [newUserNote]);

    useEffect(() => {
        if (!analysisLoading) return;
        if (analysisStep < analysisSteps.length - 1) {
            const baseDelay = 2250;
            const randomExtra = Math.random() * 3750;
            const timer = setTimeout(() => {
                setAnalysisStep(prev => prev + 1);
            }, baseDelay + randomExtra);
            return () => clearTimeout(timer);
        }
    }, [analysisStep, analysisLoading]);

    useEffect(() => {
        if (!structuredLoading) return;
        if (structuredStep < structuredSteps.length - 1) {
            const timer = setTimeout(() => {
                setStructuredStep(prev => prev + 1);
            }, 10000 / structuredSteps.length);
            return () => clearTimeout(timer);
        }
    }, [structuredStep, structuredLoading]);

    useEffect(() => {
        if (!isStreaming) { setStreamingProgress(0); return; }
        const start = Date.now();
        const duration = 6000;
        const tick = () => {
            const elapsed = Date.now() - start;
            setStreamingProgress(Math.min((elapsed / duration) * 100, 99));
            if (elapsed < duration) rafId = requestAnimationFrame(tick);
        };
        let rafId = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(rafId);
    }, [isStreaming]);

    const [uploadedImageUrls, setUploadedImageUrls] = useState(null);

    // update propertyId when property changes
    useEffect(() => {
        console.log('updating propertyId from -> to:', propertyId, property.split('-').pop())
        setPropertyId(property.split('-').pop())
    }, [property]);

    // Check if this property is already tracked
    useEffect(() => {
        const checkTracked = async () => {
            const jwt_token = localStorage.getItem('jwt_token');
            const param_token = localStorage.getItem('param_token');
            if ((!jwt_token && !param_token) || !propertyId) return;
            try {
                const response = await handleTokenAndPostRequest(
                    `${window.api_host}/check-property-tracked`,
                    { property_value: propertyId }
                );
                if (response.data.tracked) {
                    setIsPropertyTracked(true);
                }
            } catch (err) {
                console.log('check-property-tracked error:', err);
            }
        };
        checkTracked();
    }, [propertyId]);

    useEffect(() => {
        if (agentDetails && propertyData) {
          const title = `${propertyData.address_text} Real Estate Insights by ${agentDetails.agency_name_short}`;
      
          const description = `Explore in-depth real estate insights and market trends for ${propertyData.address_text}. Discover detailed property values, recent sales data, rental market analysis, and comprehensive local reports. Utilize our self-appraisal tool to add in the property features and receive a free live valuation. Try the comparable valuation tool by selecting your comparables to get an accurate valuation. The page also provides the property's transaction and rental history. Brought to you by ${agentDetails.agency_name_short}, your trusted source for real estate information.`;
      
          const keywords = `Real Estate, ${propertyData.address_text} Properties, Market Trends, Property Values, ${agentDetails.agency_name_short}, Local Reports, Median Prices, Rental Market, Sales Data, Property Types, Real Estate Insights, Housing Market, Self-Appraisal Tool, Comparable Valuation Tool, Property Transaction History, Rental History`;
      
          const url = `https://homeprice.site/property-profile/${property}`;
          const image = agentDetails.landing_background_url;
      
          setMetaTags({ title, description, keywords, url, image });
        }
      }, [agentDetails, propertyData]);


    const handleDeletedUrl = (url) => {
        // Remove the deleted URL from the uploadedImageUrls
        setUploadedImageUrls((prevUploadedImageUrls) => prevUploadedImageUrls.filter((imageUrl) => imageUrl !== url));
        console.log('Deleted URL:', url);
    
        // Update the mediaUrls state by removing the deleted URL
        setMediaUrls((prevMediaUrls) => prevMediaUrls.filter((mediaUrl) => mediaUrl !== url));
    };
    const handleUploadedUrls = async (urls) => {
        // Append new URLs to the existing uploadedImageUrls
        setUploadedImageUrls((prevUploadedImageUrls) => [...prevUploadedImageUrls, ...urls]);
        console.log('Uploaded URLs:', urls);
    
        // Update the mediaUrls state directly
        setMediaUrls((prevMediaUrls) => [...urls, ...(prevMediaUrls || [])]);
    
        setActiveIndex(0);
    
        try {
            // Make the API request to process images
            const response = await handleTokenAndPostRequest(
                `${window.api_host}/process-images`,
                {
                    property_id: propertyId, // Ensure propertyId is available in the scope
                    image_urls: urls
                },
                {
                    'Content-Type': 'application/json',
                }
            );
    
            // Update pros and cons by adding to them
            setProFeatures((prevPros) => [
                ...prevPros,
                ...response.data.pro_features
                    .map(pro => proFeatureOptions.find(option => option.value === pro))
                    .filter(pro => pro !== undefined) // Filter out undefined values
            ]);
            
            setConFeatures((prevCons) => [
                ...prevCons,
                ...response.data.con_features
                    .map(con => conFeatureOptions.find(option => option.value === con))
                    .filter(con => con !== undefined) // Filter out undefined values
            ]);
    
        } catch (error) {
            console.error('Error processing images:', error);
            // Handle error appropriately
        }
    };

    // Scroll depth tracking (25%, 50%, 75%)
    const scrollMilestonesRef = useRef(new Set());
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY || window.pageYOffset;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (docHeight <= 0) return;
            const pct = (scrollTop / docHeight) * 100;
            [25, 50, 75].forEach(milestone => {
                if (pct >= milestone && !scrollMilestonesRef.current.has(milestone)) {
                    scrollMilestonesRef.current.add(milestone);
                    trackEvent('scroll_depth', { percent: milestone });
                }
            });
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    const handleSelect = (selectedIndex) => {
        setActiveIndex(selectedIndex);
    };    

    const handleShowShareModal = () => { trackEvent('modal_open_share'); setShowShareModal(true); };
    
    const handleHideShareModal = () => { trackEvent('modal_close_share'); setShowShareModal(false); };
  
    const handleCopySuccess = () => {
      setCopySuccess(true);
      setTimeout(() => {
        setCopySuccess(false);
      }, 5000); // Hide the toast after 5 seconds
    };

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const param_token = params.get('token');


    const jwt_token = localStorage.getItem('jwt_token');

    const animatedComponents = makeAnimated();
    const navigate = useNavigate();
    
    // showToast is now managed directly in the analysisNeeded useEffect below
    
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1200);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);    

    useEffect(() => {
        if (agentDetails) {
            document.title = `${agentDetails.agency_name_short} Property Report`;
            document.documentElement.style.setProperty('--nav-link-active-border-color', agentDetails.agent_colour);
            document.documentElement.style.setProperty('--nav-link-active-color', agentDetails.agent_button_colour);            
            document.documentElement.style.setProperty('--nav-link-font-size', isMobile ? '0.8rem' : '1rem');            
        }
    }, [agentDetails]);

    useEffect(() => {
        if (!propertyLoading) {
            console.log("Loading property!");
            // Abort any in-progress analysis from the previous property
            if (analysisAbortRef.current) {
                analysisAbortRef.current.abort();
                analysisAbortRef.current = null;
            }
            setPropertyLoading(true);
            setPropertyAnalysisData(null);
            setAnalysisLoading(false);
            setStreamingAiSummary('');
            streamingAiSummaryRef.current = '';
            if (streamingContainerRef.current) streamingContainerRef.current.innerHTML = '';
            setIsStreaming(false);
            setStructuredLoading(false);
            setAnalysisNeeded(false);
            setShowToast(false);
            setPropertyError(null);
            // Don't auto-pop the edit / estimation modals when the QR gate
            // is active — they'd open behind it and yank focus off the
            // mobile-number input the moment the user taps it. (See also the
            // useEffect below that force-closes any modal that sneaks open
            // while the gate is up — scroll-triggered ones on mobile when
            // the virtual keyboard reflows the viewport, mostly.)
            if (!showQrUnlockModal) {
                setShowEditModal(true);
                setEstimationInfoShowModal(true);
            }
            setComparableCards([]);
            setComparableResults({});
            setComparableLoading({});
            setExcludedCompIds(new Set());
            setRecalcEstimate({ sale: false, rent: false });
            setSelectingComparables(false);
            setLocationAnalysis(null);
            setLocationLoading(false);
            setLocationMapUrl('');
            setModalStep(sessionStorage.getItem('valuationToolModalSeen') ? 'edit' : 'info');
            const fetchData = async () => {
                try {
                // take the last part of the URL after the last - character
                    const slug = property.split('-').slice(0, -1).join('-');
                    
                    const response = await handleTokenAndPostRequest(
                        `${window.api_host}/property`,
                        {
                          property_id: property.split('-').pop(),
                          agent_slug: agent_slug,
                          slug: slug
                        },
                        {
                          'Content-Type': 'application/json',
                        }
                    );
                    if (!response.data || response.data.error) {
                        setPropertyError('We couldn\'t find this property. Please check the address and try again.');
                        return;
                    }
                    setPropertyData(response.data);
                    setBedrooms(response.data.bedrooms);
                    setLandArea(response.data.land_area);
                    setBathrooms(response.data.bathrooms);
                    setCarspaces(response.data.carspaces);
                    setLatitude(response.data.latitude);
                    setLongitude(response.data.longitude);
                    setState(response.data.state);
                    setPropertyType(response.data.listing_property_type);
                    setPropertyNotes(response.data.property_notes || null);
                    setSuburb(response.data.suburb_id);
                    setPostcode(response.data.postcode);
                    setMediaUrls(response.data.media_urls || []);
                    setUploadedImageUrls(response.data.uploaded_image_urls || []);
                    setProFeatures(
                        (response.data.pro_features || [])
                            .map(pro => proFeatureOptions.find(option => option.value === pro))
                            .filter(pro => pro !== undefined)
                    );
                    
                    setConFeatures(
                        (response.data.con_features || [])
                            .map(con => conFeatureOptions.find(option => option.value === con))
                            .filter(con => con !== undefined)
                    );

                    setSavedProFeatures((response.data.saved_pro_features || []).map(pro => proFeatureOptions.find(option => option.value === pro)));
                    setSavedConFeatures((response.data.saved_con_features || []).map(con => conFeatureOptions.find(option => option.value === con)));
                    setSavedBedrooms(response.data.saved_bedrooms);
                    setSavedLandArea(response.data.saved_land_area);
                    setSavedBathrooms(response.data.saved_bathrooms);
                    setSavedCarspaces(response.data.saved_carspaces);
                    setSavedPropertyType(response.data.saved_property_type);
                    setSavedMediaUrls(response.data.saved_media_urls || []);
                    setSavedUploadedImageUrls(response.data.saved_uploaded_image_urls || []);
                    setSavedPropertyNotes(response.data.saved_property_notes || null);
                
                } catch (error) {
                    console.log("Error fetching /property data", error);
                    setPropertyError('Something went wrong loading this property. Please try again.');
                } finally {
                    setPropertyLoading(false);
                }
            };
            fetchData();
        }
    }, [property, agent_slug]);

    // Fetch "what's on the market now" — currently-live nearby listings. Runs
    // as soon as we know the property's location, independently of the AI
    // analysis, so the section is populated even before the user runs an
    // estimate. See backend /on-market-listings.
    useEffect(() => {
        if (!suburb || latitude == null || longitude == null) return;
        let cancelled = false;
        const fetchOnMarket = async () => {
            try {
                setOnMarketLoading(true);
                const response = await handleTokenAndPostRequest(
                    `${window.api_host}/on-market-listings`,
                    {
                        suburb_id: suburb,
                        postcode: postcode,
                        latitude: latitude,
                        longitude: longitude,
                        bedrooms: bedrooms,
                        property_type: propertyType,
                        listing_type: 'Sale',
                        limit: 12,
                    },
                    { 'Content-Type': 'application/json' }
                );
                if (cancelled) return;
                const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                setOnMarketListings(Array.isArray(data?.listings) ? data.listings : []);
            } catch (error) {
                if (!cancelled) {
                    console.log('Error fetching on-market listings', error);
                    setOnMarketListings([]);
                }
            } finally {
                if (!cancelled) setOnMarketLoading(false);
            }
        };
        fetchOnMarket();
        return () => { cancelled = true; };
    }, [suburb, postcode, latitude, longitude, bedrooms, propertyType]);

    useEffect(() => {
        if (propertyData && agentDetails) {
            const fetchAgentNotes = async () => {
                try {
                    const response = await handleTokenAndPostRequest(
                        `${window.api_host}/get-user-notes`,
                        {
                            property_id: property.split('-').pop(),
                            landing_page_slug: agentDetails.landing_page_slug,
                        },
                        { 'Content-Type': 'application/json' }
                    );
                    if (response.data && Array.isArray(response.data)) {
                        setAgentNotes(response.data);
                    }
                } catch (error) {
                    console.log('Error fetching agent notes:', error);
                }
            };
            fetchAgentNotes();
        }
    }, [propertyData, agentDetails]);

    const fetchUserNotes = useCallback(async () => {
        if (!propertyData) return;
        try {
            const response = await handleTokenAndPostRequest(
                `${window.api_host}/get-user-property-notes`,
                { property_id: property.split('-').pop() },
                { 'Content-Type': 'application/json' }
            );
            if (response.data && Array.isArray(response.data)) {
                setUserNotes(response.data);
                return response.data;
            }
        } catch (error) {
            console.log('Error fetching user notes:', error);
        }
        return null;
    }, [propertyData, property]);

    useEffect(() => {
        if (propertyData) {
            fetchUserNotes();
        }
    }, [propertyData, fetchUserNotes]);

    const handleSaveUserNote = async () => {
        if (!newUserNote.trim()) return;
        trackEvent('click_save_user_note');
        const jwt_token = localStorage.getItem('jwt_token');
        const param_token = localStorage.getItem('param_token');
        if (!jwt_token && !param_token) {
            trackEvent('modal_open_track_property_public', { trigger: 'save_user_note', property_id: propertyId });
            setShowTrackPublicModal(true);
            return;
        }
        setIsSavingUserNote(true);
        try {
            await handleTokenAndPostRequest(
                `${window.api_host}/save-user-property-note`,
                {
                    property_id: property.split('-').pop(),
                    note: newUserNote.trim(),
                    landing_page_slug: agentDetails?.landing_page_slug,
                },
                { 'Content-Type': 'application/json' }
            );
            setNewUserNote('');
            await fetchUserNotes();
        } catch (error) {
            console.log('Error saving user note:', error);
        } finally {
            setIsSavingUserNote(false);
        }
    };

    const handleDeleteUserNote = async (noteId) => {
        setDeletingNoteId(noteId);
        try {
            await handleTokenAndPostRequest(
                `${window.api_host}/delete-user-property-note`,
                { note_id: noteId },
                { 'Content-Type': 'application/json' }
            );
            await fetchUserNotes();
        } catch (error) {
            console.log('Error deleting user note:', error);
        } finally {
            setDeletingNoteId(null);
        }
    };

    useEffect(() => {
        // Check if analysis is needed based on property attributes
        const needed = (
            bedrooms !== analysedBedrooms ||
            bathrooms !== analysedBathrooms ||
            carspaces !== analysedCarspaces ||
            landArea !== analysedLandArea ||
            propertyType !== analysedPropertyType ||
            !arraysEqual(proFeatures, analysedProFeatures) || // Check if pro features differ
            !arraysEqual(conFeatures, analysedConFeatures) ||   // Check if con features differ
            !arraysEqual(mediaUrls, analysedMediaUrls) || // Check if media URLs differ
            propertyNotes !== analysedPropertyNotes || // Check if notes differ
            newUserNote.trim() !== '' || // Check if there are unsaved user notes
            JSON.stringify(userNotes) !== JSON.stringify(analysedUserNotes) // Check if saved user notes differ from last analysis
        );
        setAnalysisNeeded(needed);

        // Show snackbar when features have changed after the first analysis
        if (needed && propertyAnalysisData && !analysisLoading && !propertyLoading) {
            setShowToast(true);
        } else {
            setShowToast(false);
        }
    
        // Check if the property data is saved
        if (propertyData) {
            if (
                (savedBedrooms === bedrooms || (savedBedrooms === null && bedrooms === null)) &&
                (savedBathrooms === bathrooms || (savedBathrooms === null && bathrooms === null)) &&
                (savedCarspaces === carspaces || (savedCarspaces === null && carspaces === null)) &&
                (savedLandArea === landArea || (savedLandArea === null && landArea === null)) &&
                (savedPropertyType === propertyType || (savedPropertyType === null && propertyType === null)) &&
                arraysEqual(proFeatures, savedProFeatures) && // Check if pro features are saved
                arraysEqual(conFeatures, savedConFeatures) &&   // Check if con features are saved
                arraysEqual(mediaUrls, savedMediaUrls) && // Check if media URLs are saved
                (savedPropertyNotes === propertyNotes || (savedPropertyNotes === null && propertyNotes === null))
            ) {
                setIsSaved(true);
            } else {
                setIsSaved(false);
            }
        }
    
    }, [
        bedrooms,
        bathrooms,
        carspaces,
        propertyType,
        landArea,
        proFeatures,
        conFeatures,
        mediaUrls,
        propertyNotes,
        newUserNote,
        userNotes,
        analysisLoading,
        propertyLoading
    ]);
    
    // Helper function to compare arrays
    const arraysEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((value, index) => value === arr2[index]);
    };

    const handleAnalyseComparable = async (comp) => {
        if (comparableResults[comp.id] || comparableLoading[comp.id]) return;
        setComparableLoading(prev => ({ ...prev, [comp.id]: true }));
        const target = {
            address: propertyData?.address_text,
            bedrooms: Number(bedrooms) || 0,
            bathrooms: Number(bathrooms) || 0,
            parking: Number(carspaces) || 0,
            land_size: Number(landArea) || 0,
            property_type: typeof propertyType === 'string' ? propertyType : (propertyType?.value || 'House'),
        };
        const compPayload = {
            id: comp.id,
            address: comp.address,
            bedrooms: comp.bedrooms || 0,
            bathrooms: comp.bathrooms || 0,
            parking: comp.carspaces || 0,
            land_size: (() => {
                if (comp.land_area == null) return 0;
                if (typeof comp.land_area === 'number') return comp.land_area;
                try { return JSON.parse(comp.land_area)?.size || 0; } catch { return 0; }
            })(),
            property_type: comp.property_type || 'House',
            price: comp.price || 0,
            display_price: comp.display_price || '',
            latitude: comp.latitude,
            longitude: comp.longitude,
        };
        try {
            const res = await handleTokenAndPostRequest(
                `${window.api_host}/run-comparable-analysis`,
                { target, comparables: [compPayload], target_lat: latitude, target_lng: longitude, param_token: localStorage.getItem('param_token') },
                { 'Content-Type': 'application/json' }
            );
            const r = res.data?.results?.[0];
            if (r) {
                setComparableResults(prev => ({ ...prev, [comp.id]: { score: r.score, summary: r.summary, diff: r.diff, address: comp.address, display_price: comp.display_price, location: r.location } }));
            }
        } catch (err) {
            console.error(`Error analysing comparable ${comp.id}:`, err);
        }
        setComparableLoading(prev => { const next = { ...prev }; delete next[comp.id]; return next; });
    };

    // Fire the property_analysis_complete event so the agent alert + analytics
    // reflect exactly the comparables the user kept selected.
    const sendPropertyAnalysisCompleteEvent = (analysisData, comparables) => {
        const ctx = analysisContextRef.current;
        if (!ctx) return;
        const { requestBody, inputFeatureDict, freshUserNotes, propertyId, propertyType, bedrooms, bathrooms, carspaces, landArea } = ctx;
        const inputFeatureDictJson = JSON.stringify(inputFeatureDict, Object.keys(inputFeatureDict).sort());
        const inputFeatureDictHash = Array.from(inputFeatureDictJson).reduce((h, c) => ((h << 5) - h + c.charCodeAt(0)) | 0, 0).toString(16);

        handleTokenAndPostRequest(
            `${window.api_host}/save-settings`,
            {
                agent_slug: agent_slug,
                event_type: 'property_analysis_complete',
                property_id: propertyId,
                address_text: propertyData?.address_text || '',
                source: window.location.href,
                metadata: {
                    record_dict: analysisData,
                    request_data: { ...requestBody, comparables, comparable_analyses: comparables },
                    address_text: propertyData?.address_text || '',
                    property_type: propertyType,
                    bedrooms, bathrooms, carspaces,
                    land_area: landArea,
                    property_notes: freshUserNotes.map(n => n.note).join('\n'),
                    report_type: 'property_live',
                    input_feature_dict_hash: inputFeatureDictHash,
                    input_feature_dict_json: inputFeatureDictJson,
                },
            },
            { 'Content-Type': 'application/json' }
        ).catch(err => console.error('Error tracking property_analysis_complete:', err));
    };

    // Re-calculate the sale or rental estimate using only the comparables the
    // user has not excluded, then re-fire the analysis event with that selection.
    const recalcEstimatesForExclusions = async (excludedIdsSet, which) => {
        const ctx = analysisContextRef.current;
        if (!ctx) return;
        const fetchOpts = { 'Content-Type': 'application/json' };
        const parseResponse = (resp) => {
            let d = resp.data;
            if (typeof d === 'string') d = JSON.parse(d.replace(/\bNaN\b/g, 'null'));
            return d;
        };
        const includedComparables = ctx.comparables.filter(c => !excludedIdsSet.has(c.id));
        const estimateBody = { ...ctx.requestBody, ai_summary: '', comparables: includedComparables };
        const endpoint = which === 'sale' ? 'property-estimate-sale' : 'property-estimate-rent';

        setRecalcEstimate(prev => ({ ...prev, [which]: true }));
        try {
            const r = await handleTokenAndPostRequest(`${window.api_host}/${endpoint}`, estimateBody, fetchOpts);
            const d = parseResponse(r);
            const prev = propertyAnalysisDataRef.current || {};
            const merged = {
                ...prev,
                ...d,
                // Keep both estimate series intact — only replace the one we recalculated.
                time_series: {
                    reporting_month: d.time_series?.reporting_month || prev.time_series?.reporting_month || [],
                    valuation_estimate: which === 'sale' ? (d.time_series?.valuation_estimate || []) : (prev.time_series?.valuation_estimate || []),
                    rental_estimate: which === 'rent' ? (d.time_series?.rental_estimate || []) : (prev.time_series?.rental_estimate || []),
                },
                // Estimate endpoints don't return days data — preserve it.
                days_on_market_time_series: prev.days_on_market_time_series,
            };
            propertyAnalysisDataRef.current = merged;
            setPropertyAnalysisData(merged);
            sendPropertyAnalysisCompleteEvent(merged, includedComparables);
        } catch (e) {
            console.error('Recalc estimate error', e);
        } finally {
            setRecalcEstimate(prev => ({ ...prev, [which]: false }));
        }
    };

    // Toggle a comparable in/out of the estimate and recompute the affected side.
    const handleToggleExcludeComparable = (comp) => {
        const isSold = comp.listing_type === 'Sold';
        const next = new Set(excludedCompIds);
        const willExclude = !next.has(comp.id);
        if (willExclude) next.add(comp.id); else next.delete(comp.id);
        setExcludedCompIds(next);
        trackEvent(willExclude ? 'exclude_comparable' : 'include_comparable', { comparable_id: comp.id, listing_type: comp.listing_type });
        recalcEstimatesForExclusions(next, isSold ? 'sale' : 'rent');
    };


    const handleAnalyseProperty = async () => {
        trackEvent('click_analyse_property');
        try {
            const jwt_token = localStorage.getItem('jwt_token');
            const param_token = localStorage.getItem('param_token');
            // Logged-out users can still run the analysis. The tracking modal
            // is opened separately when they scroll to the Sale Estimate section.

            // Abort any previous analysis and create a fresh controller
            if (analysisAbortRef.current) analysisAbortRef.current.abort();
            const abortController = new AbortController();
            analysisAbortRef.current = abortController;
            const signal = abortController.signal;

            window.scrollTo({ top: 0, behavior: 'smooth' });
            setAnalysisLoading(true);
            setAnalysisStep(0);
            setPropertyAnalysisData(null);
            setStreamingAiSummary('');
            streamingAiSummaryRef.current = '';
            if (streamingContainerRef.current) streamingContainerRef.current.innerHTML = '';
            setIsStreaming(false);
            setStructuredLoading(false);
            setComparableCards([]);
            setComparableResults({});
            setComparableLoading({});
            setExcludedCompIds(new Set());
            setRecalcEstimate({ sale: false, rent: false });
            setSelectingComparables(true);

            // Save any unsaved user notes before analysing
            let freshUserNotes = userNotes;
            if (newUserNote.trim()) {
                try {
                    await handleTokenAndPostRequest(
                        `${window.api_host}/save-user-property-note`,
                        {
                            property_id: property.split('-').pop(),
                            note: newUserNote.trim(),
                            landing_page_slug: agentDetails?.landing_page_slug,
                        },
                        { 'Content-Type': 'application/json', signal }
                    );
                    setNewUserNote('');
                    const fetched = await fetchUserNotes();
                    if (fetched) freshUserNotes = fetched;
                } catch (error) {
                    console.log('Error saving user note before analysis:', error);
                }
            }

            const requestBody = {
                property_id: propertyId,
                bedrooms: bedrooms,
                bathrooms: bathrooms,
                carspaces: carspaces,
                land_area: landArea,
                property_type: propertyType,
                pro_features: proFeatures.map(feature => feature.value),
                con_features: conFeatures.map(feature => feature.value),
                property_notes: [
                    ...freshUserNotes.map(n => ({ id: n.id, note: n.note, created_at: n.created_at, source: 'user' })),
                    ...agentNotes.map(n => ({ id: n.id, note: n.note, created_at: n.created_at, source: 'agent' })),
                ],
                last_sold_date: propertyData.sold_date,
                last_sold_price: propertyData.sold_price,
                last_rented_date: propertyData.rented_date,
                last_rented_price: propertyData.rented_price,
                state: state,
                postcode: postcode,
                latitude: latitude,
                longitude: longitude,
                agent_slug: agent_slug,
                page: 'PropertyProfile',
                media_urls: mediaUrls,
                uploaded_image_urls: uploadedImageUrls,
                suburb_id: suburb,
                report_type: 'property_live',
                address_text: propertyData.address_text,
                param_token: localStorage.getItem('param_token'),
                source: window.location.href,
                num_comparables: 4,
                analysis_type: { sale: true, rental: true },
            };



            // --- Step 1: Select best comparables (sale + rental in parallel) ---
            const selectPayload = {
                property_id: propertyId,
                suburb_id: suburb,
                latitude: latitude,
                longitude: longitude,
                bedrooms: bedrooms,
                bathrooms: bathrooms,
                carspaces: carspaces,
                land_area: landArea,
                property_type: propertyType,
                address_text: propertyData.address_text,
                num_comparables: 4,
                param_token: localStorage.getItem('param_token'),
                postcode: postcode,
            };

            const [saleSelectRes, rentalSelectRes] = await Promise.all([
                handleTokenAndPostRequest(
                    `${window.api_host}/select-comparables`,
                    { ...selectPayload, analysis_type: { sale: true, rental: false } },
                    { 'Content-Type': 'application/json', signal }
                ),
                handleTokenAndPostRequest(
                    `${window.api_host}/select-comparables`,
                    { ...selectPayload, analysis_type: { sale: false, rental: true } },
                    { 'Content-Type': 'application/json', signal }
                ),
            ]);

            const selectedComparables = [
                ...(saleSelectRes.data?.comparables || []),
                ...(rentalSelectRes.data?.comparables || []),
            ];
            setComparableCards(selectedComparables);
            setSelectingComparables(false);

            // --- Step 2: Auto-trigger location analysis (non-blocking) ---
            if (selectedComparables.length > 0 && latitude && longitude) {
                setLocationLoading(true);
                setLocationAnalysis(null);
                setLocationMapUrl('');
                const saleComps = selectedComparables.filter(c => c.listing_type === 'Sold' && c.latitude && c.longitude).map(c => ({
                    id: c.id, display_address: c.address, price: c.price, latitude: c.latitude, longitude: c.longitude,
                    bedrooms: c.bedrooms, bathrooms: c.bathrooms, carspaces: c.carspaces, property_type_display: c.property_type, filter_date: c.filter_date,
                }));
                const rentalComps = selectedComparables.filter(c => c.listing_type !== 'Sold' && c.latitude && c.longitude).map(c => ({
                    id: c.id, display_address: c.address, price: c.price, latitude: c.latitude, longitude: c.longitude,
                    bedrooms: c.bedrooms, bathrooms: c.bathrooms, carspaces: c.carspaces, property_type_display: c.property_type, filter_date: c.filter_date,
                }));
                handleTokenAndPostRequest(
                    `${window.api_host}/analyse-location`,
                    { address: propertyData.address_text, subject_lat: latitude, subject_lng: longitude, sale_comparables: saleComps, rental_comparables: rentalComps, param_token: localStorage.getItem('param_token') },
                    { 'Content-Type': 'application/json', signal }
                ).then(res => {
                    setLocationAnalysis(res.data?.analysis || null);
                    setLocationMapUrl(res.data?.map_url || '');
                }).catch(err => {
                    console.error('Auto location analysis error:', err);
                }).finally(() => {
                    setLocationLoading(false);
                });
            }

            // --- Step 3: Build comparables list for estimate endpoints ---
            const comparables = selectedComparables.map(c => ({
                id: c.id,
                address: c.address,
                display_price: c.display_price || '',
                bedrooms: c.bedrooms,
                bathrooms: c.bathrooms,
                carspaces: c.carspaces,
                land_area: c.land_area,
                listing_type: c.listing_type,
                filter_date: c.filter_date || c.sold_timestamp,
                property_type: c.property_type,
                price: c.price,
                latitude: c.latitude,
                longitude: c.longitude,
                photo_url_main: c.photo_url_main || null,
            }));

            // --- Step 4: Fetch estimates in parallel (4 endpoints) ---
            setStructuredLoading(true);
            setStructuredStep(0);

            const estimateBody = {
                ...requestBody,
                ai_summary: '',
                comparables: comparables,
            };
            const daysBody = { suburb_id: suburb };
            const fetchOpts = { 'Content-Type': 'application/json', signal };

            const parseResponse = (resp) => {
                let d = resp.data;
                if (typeof d === 'string') d = JSON.parse(d.replace(/\bNaN\b/g, 'null'));
                return d;
            };

            // Fire all 4 in parallel
            const [saleEstP, rentEstP, saleDaysP, rentDaysP] = [
                handleTokenAndPostRequest(`${window.api_host}/property-estimate-sale`, estimateBody, fetchOpts)
                    .then(r => { const d = parseResponse(r); setPropertyAnalysisData(prev => ({ ...prev, ...d })); return d; })
                    .catch(e => { console.error('Sale estimate error', e); return null; }),
                handleTokenAndPostRequest(`${window.api_host}/property-estimate-rent`, estimateBody, fetchOpts)
                    .then(r => { const d = parseResponse(r); setPropertyAnalysisData(prev => ({ ...prev, ...d })); return d; })
                    .catch(e => { console.error('Rent estimate error', e); return null; }),
                handleTokenAndPostRequest(`${window.api_host}/property-days-sale`, daysBody, fetchOpts)
                    .then(r => { const d = parseResponse(r); setPropertyAnalysisData(prev => ({ ...prev, ...d })); return d; })
                    .catch(e => { console.error('Sale days error', e); return null; }),
                handleTokenAndPostRequest(`${window.api_host}/property-days-rent`, daysBody, fetchOpts)
                    .then(r => { const d = parseResponse(r); setPropertyAnalysisData(prev => ({ ...prev, ...d })); return d; })
                    .catch(e => { console.error('Rent days error', e); return null; }),
            ];

            const [saleEst, rentEst, saleDays, rentDays] = await Promise.all([saleEstP, rentEstP, saleDaysP, rentDaysP]);

            // Merge time_series from both estimate endpoints
            const mergedTimeSeries = {
                reporting_month: saleEst?.time_series?.reporting_month || rentEst?.time_series?.reporting_month || [],
                valuation_estimate: saleEst?.time_series?.valuation_estimate || [],
                rental_estimate: rentEst?.time_series?.rental_estimate || [],
            };
            const mergedDaysTimeSeries = {
                reporting_month: saleDays?.days_on_market_time_series?.reporting_month || rentDays?.days_on_market_time_series?.reporting_month || [],
                median_sold_days_on_market: saleDays?.days_on_market_time_series?.median_sold_days_on_market || [],
                median_rent_days_on_market: rentDays?.days_on_market_time_series?.median_rent_days_on_market || [],
            };

            const analysisData = {
                property_id: propertyId,
                ...(saleEst || {}),
                ...(rentEst || {}),
                ...(saleDays || {}),
                ...(rentDays || {}),
                time_series: mergedTimeSeries,
                days_on_market_time_series: mergedDaysTimeSeries,
                ai_summary: '',
                ai_summary_truncated: '',
                history: propertyData?.history || [],
            };

            setPropertyAnalysisData(analysisData);
            setStructuredLoading(false);

            // --- Step 5: Track property_analysed event + send agent alert via save-settings ---
            const inputFeatureDict = {
                bedrooms, bathrooms, carspaces,
                property_type: propertyType,
                land_area_size: landArea,
                state, postcode, latitude, longitude,
                days_from: 0,
                pro_features: proFeatures.map(f => f.value),
                con_features: conFeatures.map(f => f.value),
                user_notes: freshUserNotes.map(n => n.note).join('\n'),
                media_urls: mediaUrls,
                uploaded_image_urls: uploadedImageUrls,
                agent_notes: '',
                num_comparables: 4,
                analysis_type: { sale: true, rental: true },
            };
            // Store the analysis inputs so estimates can be re-calculated when the
            // user excludes/includes comparables without re-running the whole analysis.
            analysisContextRef.current = {
                requestBody, comparables, freshUserNotes, inputFeatureDict,
                propertyId, propertyType, bedrooms, bathrooms, carspaces, landArea,
            };

            sendPropertyAnalysisCompleteEvent(analysisData, comparables);

            setAnalysedBathrooms(bathrooms);
            setAnalysedBedrooms(bedrooms);
            setAnalysedProFeatures(proFeatures);
            setAnalysedConFeatures(conFeatures);
            setAnalysedCarspaces(carspaces);
            setAnalysedLandArea(landArea);
            setAnalysedPropertyType(propertyType);
            setAnalysedMediaUrls(mediaUrls);
            setAnalysedPropertyNotes(propertyNotes);
            setAnalysedUserNotes(freshUserNotes);
            setAnalysisNeeded(false);

            return analysisData;
        } catch (error) {
            if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED' || error?.message === 'canceled') {
                console.log('Property analysis cancelled');
                return;
            }
            console.error("Error fetching property analysis data", error);
        } finally {
            if (streamingAiSummaryRef.current && !streamingAiSummary) {
                setStreamingAiSummary(streamingAiSummaryRef.current);
            }
            setAnalysisLoading(false);
            setIsStreaming(false);
            setStructuredLoading(false);
            setSelectingComparables(false);
        }
    };

    const handleModalSuccess = () => {
        setModalShow(false);
        handleAnalyseProperty();
    }

    const handleCloseEditModal = () => {
        setEstimationInfoShowModal(false);
        setShowEditModal(false);

        if (modalStep === 'edit' && !propertyAnalysisData && !analysisLoading) {
            handleAnalyseProperty();
        }
    };

    useEffect(() => {
        if (agentDetails) {
            document.title = `${agentDetails.agency_name_short} Property Report`;
        }
    }, [agentDetails]);

    // Mark the review-attributes modal as seen the first time it's shown in this session.
    useEffect(() => {
        if (modalStep === 'edit' && (showEditModal || estimationInfoShowModal)) {
            sessionStorage.setItem('reviewAttributesSeen', 'true');
        }
    }, [modalStep, showEditModal, estimationInfoShowModal]);

    // Logged-out: open the track-property modal the first time the user
    // actually scrolls to the 'sale-estimate' section. Once per session only,
    // and never on the initial default-active state (no scroll yet).
    const hasUserScrolledRef = useRef(false);
    useEffect(() => {
        const onFirstScroll = () => { hasUserScrolledRef.current = true; };
        window.addEventListener('scroll', onFirstScroll, { passive: true, once: true });
        return () => window.removeEventListener('scroll', onFirstScroll);
    }, []);
    useEffect(() => {
        if (showQrUnlockModal) return; // QR gate owns the screen — see PropertyQrUnlockModal
        if (activeSection !== 'sale-comparables') return;
        if (!hasUserScrolledRef.current) return;
        const jwt_token = localStorage.getItem('jwt_token');
        const param_token = localStorage.getItem('param_token');
        if (jwt_token || param_token) return;
        if (sessionStorage.getItem('trackPropertyModalShown') === 'true') return;
        sessionStorage.setItem('trackPropertyModalShown', 'true');
        trackEvent('modal_open_track_property_public', { trigger: 'sale_comparables_section', property_id: propertyId });
        setShowTrackPublicModal(true);
    }, [activeSection, propertyId, showQrUnlockModal]);

    if (!agentDetails || propertyLoading || (!propertyData && !propertyError)) {
    return (
        <>
            {/* Show the gate before anything else paints. Branding fields are
                still loading at this point so the panel may briefly use
                fallback colour/agency name; they'll fill in as state lands. */}
            {showQrUnlockModal && (
                <PropertyQrUnlockModal
                    loading
                    address={propertyData?.address_text}
                    imageUrl={mediaUrls && mediaUrls.length > 0 ? mediaUrls[0] : null}
                    propertyId={propertyId}
                    propertySlug={property}
                    agentSlug={agent_slug || agentDetails?.landing_page_slug}
                    agencyName={agentDetails?.agency_name_short || agentDetails?.agency_name}
                    agentName={agentDetails?.agent_name}
                    agentColour={agentDetails?.agent_colour}
                    agentColourLightness={agentDetails?.agent_colour_lightness}
                    logoUrl={agentDetails?.logo_url}
                    campaign={qrCampaign}
                />
            )}
            {/* Only render the page-level loading spinner when the QR gate
                isn't taking over — the gate's own skeleton is the loading
                state in that case. */}
            {!showQrUnlockModal && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}>
                    <Spinner animation="border" />
                </div>
            )}
        </>
    );
    }

    if (propertyError || !propertyData) {
    return (
        <div style={{ 
        position: 'absolute', 
        top: '50%', 
        left: '50%', 
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        maxWidth: 400,
        padding: '0 20px',
        }}>
        <FaSearch style={{ fontSize: '2rem', color: '#adb5bd', marginBottom: 12 }} />
        <h5 style={{ fontWeight: 600, color: '#333' }}>Property not found</h5>
        <p style={{ color: '#888', fontSize: '0.9rem' }}>{propertyError || 'We couldn\'t find this property. Please check the address and try again.'}</p>
        </div>
    );
    }

    const { accentColor, buttonTextColor, isLight, iconColor, iconBgColor } = branding;
    // For light-branded agencies (e.g. white primary colour), the agent_colour itself is too pale
    // to read as a top-border accent on white cards, so fall back to black.
    const agentAccentColor = isLight ? '#111' : (agentDetails?.agent_colour || accentColor);
    // Which report sections this agent has chosen to show. Configured in the
    // agent platform's Settings → Platform Config and surfaced on agentDetails
    // via the /agency endpoint as property_report_config.sections. Days-to-sell
    // and days-to-rent default off (historically hidden); everything else on.
    const reportSectionConfig = (() => {
        const defaults = {
            'sale-estimate': true,
            'sale-comparables': true,
            'sale-days': false,
            'rent-estimate': true,
            'rent-comparables': true,
            'rent-days': false,
            'on-market': true,
            'location': true,
            'history': true,
        };
        const cfg = agentDetails?.property_report_config;
        if (cfg && Array.isArray(cfg.sections)) {
            cfg.sections.forEach((s) => {
                if (s && typeof s.key === 'string' && Object.prototype.hasOwnProperty.call(defaults, s.key)) {
                    defaults[s.key] = s.enabled !== false;
                }
            });
        }
        return defaults;
    })();
    const isSectionVisible = (key) => reportSectionConfig[key] !== false;
    const agentPhone = agentDetails?.agent_phone || agentDetails?.phone || agentDetails?.mobile || '';
    const agentFirstName = agentDetails?.agent_first_name || (agentDetails?.agent_name || '').split(' ')[0] || 'the agent';
    const formatAgentPhone = (raw) => {
        if (!raw) return raw;
        const digits = String(raw).replace(/[^\d+]/g, '');
        let local = null;
        if (digits.startsWith('+61') && digits.length === 12) local = '0' + digits.slice(3);
        else if (digits.startsWith('61') && digits.length === 11) local = '0' + digits.slice(2);
        else if (digits.startsWith('0') && digits.length === 10) local = digits;
        if (local && local.length === 10) return `${local.slice(0,4)} ${local.slice(4,7)} ${local.slice(7)}`;
        return raw;
    };
    const handleRefineComparables = (which) => {
        trackEvent('refine_comparables_click', { which, property_id: propertyId });
        if (which === 'sale') setShowAllSaleComps(true); else setShowAllRentComps(true);
        const ref = which === 'sale' ? saleComparablesRef : rentComparablesRef;
        setTimeout(() => {
            if (ref?.current) {
                const barH = 120;
                const y = ref.current.getBoundingClientRect().top + window.scrollY - barH - 8;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }, 80);
    };
    // Shared button styles — keep CTAs consistent across the page.
    // Shared button styles — keep CTAs consistent across the page (matches the
    // pill style already used by Track Property / Share at the top of the page).
    const btnPrimaryStyle = {
        flex: '1 1 140px', minWidth: 0,
        background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}dd 100%)`,
        color: buttonTextColor,
        border: isLight ? '1px solid #222' : 'none',
        borderRadius: 999,
        fontWeight: 700,
        fontSize: '0.85rem',
        padding: '10px 18px',
        cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        whiteSpace: 'nowrap',
        boxShadow: `0 2px 12px ${accentColor}30`,
        transition: 'all 0.2s',
        letterSpacing: '-0.01em',
        textDecoration: 'none',
    };
    const btnSecondaryStyle = {
        flex: '1 1 140px', minWidth: 0,
        background: '#fff',
        color: '#1a1a1a',
        border: `1px solid ${isLight ? '#e5e7eb' : `${accentColor}33`}`,
        borderRadius: 999,
        fontWeight: 600,
        fontSize: '0.85rem',
        padding: '10px 18px',
        cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        whiteSpace: 'nowrap',
        transition: 'all 0.2s',
        textDecoration: 'none',
    };
    const btnPillSecondaryStyle = {
        background: '#fff',
        color: accentColor,
        border: `1px solid ${accentColor}40`,
        borderRadius: 999,
        fontWeight: 600,
        fontSize: '0.85rem',
        padding: '10px 20px',
        cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', gap: 6,
        whiteSpace: 'nowrap',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        transition: 'all 0.2s',
    };
    const handleRevealAgentPhone = (which) => {
        if (phoneRevealed[which]) return;
        setPhoneRevealed(prev => ({ ...prev, [which]: true }));
        // Use event_type 'click_agent_phone' so the backend fires its existing
        // agent-alert email path (see /save-settings handler).
        trackEvent('click_agent_phone', { phone: agentPhone, source: `${which}_estimate`, property_id: propertyId, action: 'reveal' });
        handleTokenAndPostRequest(
            `${window.api_host}/save-settings`,
            {
                agent_slug: agentDetails?.landing_page_slug,
                event_type: 'click_agent_phone',
                metadata: {
                    property_address: propertyData?.address_text || '',
                    property_id: propertyId,
                    phone: agentPhone,
                    source: `${which}_estimate`,
                    action: 'reveal',
                },
            },
            { 'Content-Type': 'application/json' }
        ).catch(err => console.error('Error saving click_agent_phone event:', err));
    };
    const tileBorderColor = isLight ? `${accentColor}40` : '#f0f0f0';
    const panelBorderColor = isLight ? `${accentColor}4d` : '#e5e7eb';
    const sectionTopBorder = `3px solid ${agentAccentColor}`;
    const propertyTypeLabel = typeof propertyType === 'string' ? propertyType : propertyType?.label;

    const formatPercentChange = (value) => {
        const formattedValue = Math.abs(value);
        if (formattedValue === 0) {
            return 0;
        }
        // if null then return 'N/A'
        if (value === null) {
            return 'N/A';
        }
        return formattedValue;
    };
    const PremiumTrendChart = ({
        dates,
        values,
        title,
        subtitle,
        accentColor,
        isMobile,
        isCurrency = false,
        valueSuffix = '',
    }) => {
        if (!dates?.length || !values?.length) return null;

        const paired = values
            .map((value, idx) => ({ value, date: dates[idx] }))
            .filter((item) => item.value !== null && item.value !== undefined && !Number.isNaN(Number(item.value)))
            .sort((a, b) => new Date(a.date) - new Date(b.date));

        if (paired.length < 2) return null;

        const cleanValues = paired.map((item) => Number(item.value));
        const cleanDates = paired.map((item) => item.date);
        const chartData = paired.map((item) => ({ date: item.date, value: Number(item.value) }));
        const firstValue = cleanValues[0];
        const lastValue = cleanValues[cleanValues.length - 1];
        const delta = lastValue - firstValue;
        const pctChange = firstValue > 0 ? ((delta / firstValue) * 100).toFixed(1) : null;
        const firstDate = cleanDates[0];
        const lastDate = cleanDates[cleanDates.length - 1];
        const gradientId = `trend-fill-${String(firstDate)}-${String(lastDate)}`.replace(/[^a-zA-Z0-9-]/g, '').slice(-42);

        const formatPointValue = (value) => {
            if (isCurrency) return formatCurrency(value);
            return `${Math.round(value)}${valueSuffix ? ` ${valueSuffix}` : ''}`;
        };

        const formatLabel = (raw) => {
            const date = new Date(raw);
            if (Number.isNaN(date.getTime())) return raw;
            return date.toLocaleDateString('en-AU', { month: 'short', year: '2-digit' });
        };

        const formatTickValue = (value) => {
            if (isCurrency) {
                if (Math.abs(value) >= 1000000) return `$${(value / 1000000).toFixed(1)}m`;
                if (Math.abs(value) >= 1000) return `$${Math.round(value / 1000)}k`;
                return `$${Math.round(value)}`;
            }
            return `${Math.round(value)}`;
        };

        const ChartTooltip = ({ active, payload, label }) => {
            if (!active || !payload?.length) return null;
            return (
                <div style={{
                    background: '#fff',
                    borderRadius: 10,
                    padding: '10px 14px',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
                    border: '1px solid #e5e7eb',
                }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', marginBottom: 6 }}>
                        {formatLabel(label)}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: accentColor }} />
                        <span style={{ color: '#374151' }}>{title || 'Value'}:</span>
                        <span style={{ fontWeight: 700, color: '#1f2937' }}>{formatPointValue(payload[0].value)}</span>
                    </div>
                </div>
            );
        };

        return (
            <div
                style={{
                    borderRadius: 20,
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
                    borderTop: sectionTopBorder,
                    border: `1px solid ${panelBorderColor}`,
                }}
            >
                <div style={{ padding: isMobile ? '20px 20px' : '28px 32px' }}>
                    {title && (
                        <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 600, color: '#9ca3af', marginBottom: subtitle ? 8 : 20 }}>
                            {title}
                        </div>
                    )}
                    {subtitle && (
                        <p style={{ margin: '0 0 16px', fontSize: '0.82rem', color: '#6b7280', lineHeight: 1.5 }}>
                            {subtitle}
                        </p>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 16 }}>
                        <div>
                            <span style={{ fontSize: isMobile ? '1.35rem' : '1.6rem', fontWeight: 700, color: '#1a1a1a' }}>
                                {formatPointValue(lastValue)}
                            </span>
                            <span style={{ fontSize: '0.78rem', color: '#9ca3af', marginLeft: 8 }}>
                                latest
                            </span>
                        </div>
                        {pctChange !== null && (
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    fontSize: '0.78rem',
                                    fontWeight: 600,
                                    color: delta >= 0 ? '#16a34a' : '#dc2626',
                                }}
                            >
                                {delta >= 0 ? <FaArrowUp size={10} /> : <FaArrowDown size={10} />}
                                {delta >= 0 ? '+' : ''}
                                {pctChange}%
                            </span>
                        )}
                    </div>

                    <div style={{ width: '100%', height: isMobile ? 190 : 230 }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={chartData} margin={{ top: 6, right: 14, left: isMobile ? -10 : 0, bottom: 6 }}>
                                <defs>
                                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor={accentColor} stopOpacity={0.16} />
                                        <stop offset="95%" stopColor={accentColor} stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
                                <XAxis
                                    dataKey="date"
                                    tickFormatter={formatLabel}
                                    fontSize={11}
                                    tick={{ fill: '#9ca3af' }}
                                    axisLine={{ stroke: '#e5e7eb' }}
                                    tickLine={false}
                                    minTickGap={isMobile ? 24 : 18}
                                />
                                <YAxis
                                    tickFormatter={formatTickValue}
                                    fontSize={11}
                                    tick={{ fill: '#9ca3af' }}
                                    axisLine={false}
                                    tickLine={false}
                                    width={isMobile ? 54 : 64}
                                />
                                <RechartsTooltip content={<ChartTooltip />} />
                                <Area
                                    type="monotone"
                                    dataKey="value"
                                    stroke={accentColor}
                                    fill={`url(#${gradientId})`}
                                    strokeWidth={2}
                                    dot={false}
                                    isAnimationActive={false}
                                    animationDuration={0}
                                    activeDot={{ r: 4, stroke: accentColor, strokeWidth: 2, fill: '#fff' }}
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                        <span style={{ fontSize: '0.68rem', color: '#b8b5af' }}>{formatLabel(firstDate)}</span>
                        <span style={{ fontSize: '0.68rem', color: '#b8b5af' }}>{formatLabel(lastDate)}</span>
                    </div>
                </div>
            </div>
        );
    };
    
    const PropertyMetric = ({
        title,
        metric_definition,
        lowerValue,
        midValue,
        upperValue,
        percentChangeLastMonth,
        percentChangeYearAgo,
        percentChange3YearsAgo,
        percentChangeLastTransacted,

        estimateLastMonth,
        estimateYearAgo,
        estimate3YearsAgo,
        lastTransactedValue,
        lastTransactedDate,
        lastTransactedLabel,

        midColor,
        time_series_date,
        time_series_value,
        yxaxis_label,
        is_currency,
        showTimeSeries,
        showComparisonCards = true,
        footerSlot = null,
    }) => {
        const margin_bottom_p = '0.25rem';

        const validIndices = (time_series_value || []).map((v, i) => (!isNaN(v) && v !== null) ? i : -1).filter(i => i !== -1);
        const filteredDates = validIndices.map(i => time_series_date[i]);
        const filteredValues = validIndices.map(i => time_series_value[i]);

        return (
            <div style={{ marginBottom: '2rem', padding: '1.25rem', border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder, borderRadius: 16, backgroundColor: '#fff', boxShadow: '0 2px 16px rgba(0,0,0,0.04)' }}>
                <ToastContainer
                    style={{
                        position: 'fixed',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 9998,
                        opacity: 1
                    }}
                    className={`p-3 ${isMobile ? 'toast-container-mobile' : 'toast-container-desktop'}`}
                >
                    <Toast onClose={() => setCopySuccess(false)} show={copySuccess} delay={2000} autohide>
                        <Toast.Body className="text-center">Link copied to clipboard</Toast.Body>
                    </Toast>
                </ToastContainer>

                <h5 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#1a1a1a', marginBottom: '4px' }}>{title}</h5>
                <p style={{ fontSize: '0.85rem', color: '#888', marginBottom: '16px' }}>{metric_definition}</p>

                <div style={{ padding: 0 }}>
                    <ValueDisplayGroup
                        lowerValue={lowerValue}
                        midValue={midValue}
                        upperValue={upperValue}
                        midColor={midColor}
                        showTitle={false}
                    />

                    {showTimeSeries && showComparisonCards && (
                        <div style={{ marginTop: '1rem' }}>
                            <Row style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                <Col xs={6} sm={6} md={3}>
                                    <Card style={{ margin: '0.5rem 0', textAlign: 'center', borderRadius: 12, border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder }}>
                                        <Card.Body style={{ padding: '14px 10px' }}>
                                            <div style={{ display: 'inline-block', cursor: 'pointer', marginBottom: '0.4rem' }}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-comparison">
                                                            Last Month: {formatCurrency(estimateLastMonth)}
                                                            <br />
                                                            Current: {(midValue)}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p style={{ marginBottom: margin_bottom_p, color: iconColor, borderBottom: '1px dotted #ccc', display: 'inline', fontSize: '0.8rem', fontWeight: 500 }}>
                                                        From Last Month:
                                                    </p>
                                                </OverlayTrigger>
                                            </div>
                                            <strong style={{ color: (percentChangeLastMonth) > 0 ? 'green' : (percentChangeLastMonth) < 0 ? 'red' : 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {(percentChangeLastMonth) > 0 ? (
                                                    <>
                                                        <FaArrowUp style={{ color: 'green', marginRight: '0.3rem' }} />
                                                        {formatPercentChange(percentChangeLastMonth)}%
                                                    </>
                                                ) : (percentChangeLastMonth) < 0 ? (
                                                    <>
                                                        <FaArrowDown style={{ color: 'red', marginRight: '0.3rem' }} />
                                                        {formatPercentChange(percentChangeLastMonth)}%
                                                    </>
                                                ) : (
                                                    <>
                                                        {formatPercentChange(percentChangeLastMonth)}%
                                                    </>
                                                )}
                                            </strong>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col xs={6} sm={6} md={3}>
                                    <Card style={{ margin: '0.5rem 0', textAlign: 'center', borderRadius: 12, border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder }}>
                                        <Card.Body style={{ padding: '14px 10px' }}>
                                            <div style={{ display: 'inline-block', cursor: 'pointer', marginBottom: '0.4rem' }}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-comparison">
                                                            1 Year Ago: {formatCurrency(estimateYearAgo)}
                                                            <br />
                                                            Current: {(midValue)}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p style={{ marginBottom: margin_bottom_p, color: iconColor, borderBottom: '1px dotted #ccc', display: 'inline', fontSize: '0.8rem', fontWeight: 500 }}>
                                                        From 1 Year Ago:
                                                    </p>
                                                </OverlayTrigger>
                                            </div>

                                            <strong style={{ color: (percentChangeYearAgo) > 0 ? 'green' : (percentChangeYearAgo) < 0 ? 'red' : 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {(percentChangeYearAgo) > 0 ? (
                                                    <>
                                                        <FaArrowUp style={{ color: 'green', marginRight: '0.3rem' }} />
                                                        {formatPercentChange(percentChangeYearAgo)}%
                                                    </>
                                                ) : (percentChangeYearAgo) < 0 ? (
                                                    <>
                                                        <FaArrowDown style={{ color: 'red', marginRight: '0.3rem' }} />
                                                        {formatPercentChange(percentChangeYearAgo)}%
                                                    </>
                                                ) : (
                                                    <>
                                                        {formatPercentChange(percentChangeYearAgo)}%
                                                    </>
                                                )}
                                            </strong>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col xs={6} sm={6} md={3}>
                                    <Card style={{ margin: '0.5rem 0', textAlign: 'center', borderRadius: 12, border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder }}>
                                        <Card.Body style={{ padding: '14px 10px' }}>
                                            <div style={{ display: 'inline-block', cursor: 'pointer', marginBottom: '0.4rem' }}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-comparison">
                                                            3 Years Ago: {formatCurrency(estimate3YearsAgo)}
                                                            <br />
                                                            Current: {(midValue)}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p style={{ marginBottom: margin_bottom_p, color: iconColor, borderBottom: '1px dotted #ccc', display: 'inline', fontSize: '0.8rem', fontWeight: 500 }}>
                                                        From 3 Years Ago:
                                                    </p>
                                                </OverlayTrigger>
                                            </div>

                                            <strong style={{ color: (percentChange3YearsAgo) > 0 ? 'green' : (percentChange3YearsAgo) < 0 ? 'red' : 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {(percentChange3YearsAgo) > 0 ? (
                                                    <>
                                                        <FaArrowUp style={{ color: 'green', marginRight: '0.3rem' }} />
                                                        {formatPercentChange(percentChange3YearsAgo)}%
                                                    </>
                                                ) : (percentChange3YearsAgo) < 0 ? (
                                                    <>
                                                        <FaArrowDown style={{ color: 'red', marginRight: '0.3rem' }} />
                                                        {formatPercentChange(percentChange3YearsAgo)}%
                                                    </>
                                                ) : (
                                                    <>
                                                        {formatPercentChange(percentChange3YearsAgo)}%
                                                    </>
                                                )}
                                            </strong>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col xs={6} sm={6} md={3}>
                                    <Card style={{ margin: '0.5rem 0', textAlign: 'center', borderRadius: 12, border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder }}>
                                        <Card.Body style={{ padding: '14px 10px' }}>
                                            <div style={{ display: 'inline-block', cursor: 'pointer', marginBottom: '0.4rem' }}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-comparison">
                                                            {lastTransactedLabel} Date: {lastTransactedDate ? lastTransactedDate.split('T')[0] : "N/A"}
                                                            <br />
                                                            {lastTransactedLabel} Price: {lastTransactedValue ? formatCurrency(lastTransactedValue) : "N/A"}
                                                            <br />
                                                            Current: {midValue}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p style={{ marginBottom: margin_bottom_p, color: iconColor, borderBottom: '1px dotted #ccc', display: 'inline', fontSize: '0.8rem', fontWeight: 500 }}>
                                                        From {lastTransactedLabel}:
                                                    </p>
                                                </OverlayTrigger>
                                            </div>

                                            {percentChangeLastTransacted === null ? (
                                                <strong style={{ color: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    N/A
                                                </strong>
                                            ) : (
                                                <strong style={{ color: (percentChangeLastTransacted) > 0 ? 'green' : (percentChangeLastTransacted) < 0 ? 'red' : 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {(percentChangeLastTransacted) > 0 ? (
                                                        <>
                                                            <FaArrowUp style={{ color: 'green', marginRight: '0.3rem' }} />
                                                            {formatPercentChange(percentChangeLastTransacted)}%
                                                        </>
                                                    ) : (percentChangeLastTransacted) < 0 ? (
                                                        <>
                                                            <FaArrowDown style={{ color: 'red', marginRight: '0.3rem' }} />
                                                            {formatPercentChange(percentChangeLastTransacted)}%
                                                        </>
                                                    ) : (
                                                        <>
                                                            {formatPercentChange(percentChangeLastTransacted)}%
                                                        </>
                                                    )}
                                                </strong>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    )}

                    {showTimeSeries && filteredValues.length > 0 && (
                        <div style={{ marginTop: showComparisonCards ? '12px' : '20px' }}>
                            <PremiumTrendChart
                                dates={filteredDates}
                                values={filteredValues}
                                title={yxaxis_label}
                                accentColor={accentColor}
                                isMobile={isMobile}
                                isCurrency={is_currency}
                            />
                        </div>
                    )}
                    {footerSlot}
                </div>
            </div>
        );
    };


    const handleTrackProperty = async () => {
        trackEvent('click_track_property');
        const jwt_token = localStorage.getItem('jwt_token');
        const param_token = localStorage.getItem('param_token');
        if (!jwt_token && !param_token) {
            trackEvent('modal_open_track_property_public', { trigger: 'track_property', property_id: propertyId });
            setShowTrackPublicModal(true);
            return;
        }
        setIsTogglingTrack(true);
        try {
            const action = isPropertyTracked ? 'untrack' : 'track';
            const addressLabel = propertyData?.address_text || `Property ${propertyId}`;
            const response = await handleTokenAndPostRequest(
                `${window.api_host}/toggle-track-property`,
                {
                    property_value: propertyId,
                    property_label: addressLabel,
                    action,
                    agent_slug: agent_slug,
                }
            );
            if (response.data.status === 'success') {
                setIsPropertyTracked(response.data.tracked);
                setTrackToastMessage(response.data.tracked ? 'Property tracked successfully.' : 'Property untracked.');
                setShowTrackToast(true);
            }
        } catch (error) {
            console.error('Error toggling track property:', error);
            setTrackToastMessage('Something went wrong. Please try again.');
            setShowTrackToast(true);
        } finally {
            setIsTogglingTrack(false);
        }
    };

    const handleShare = () => {
        trackEvent('click_share_valuation');
        const jwt_token = localStorage.getItem('jwt_token');
        const param_token = localStorage.getItem('param_token');
        if (!jwt_token && !param_token) {
            trackEvent('modal_open_track_property_public', { trigger: 'share_valuation', property_id: propertyId });
            setShowTrackPublicModal(true);
            return;
        }
        setShowShareModal(true);
    };


    return (
        <div style={{ paddingBottom: isMobile ? '80px' : '60px', backgroundColor: '#f5f3f0', minHeight: '100vh' }}>
            {/* QR-code unlock gate: full-screen, non-closable. The recipient
                scanned a printed card; they don't get to interact with the
                page until they leave their mobile number. */}
            {showQrUnlockModal && (
                <PropertyQrUnlockModal
                    address={propertyData?.address_text}
                    imageUrl={mediaUrls && mediaUrls.length > 0 ? mediaUrls[0] : null}
                    propertyId={propertyId}
                    propertySlug={property}
                    // On custom domains (e.g. atlasbyronbay.agency) the URL
                    // has no `?agent=` param, so useAgentDetails returns
                    // agent_slug=null and the backend resolves via domain.
                    // For the QR-modal impression alert we need a real slug
                    // — fall back to the resolved one from agentDetails.
                    agentSlug={agent_slug || agentDetails?.landing_page_slug}
                    agencyName={agentDetails?.agency_name_short || agentDetails?.agency_name}
                    agentName={agentDetails?.agent_name}
                    agentColour={agentDetails?.agent_colour}
                    agentColourLightness={agentDetails?.agent_colour_lightness}
                    logoUrl={agentDetails?.logo_url}
                    campaign={qrCampaign}
                />
            )}
            {/* ═══ UNIFIED STICKY BANNER ═══ */}
            <div ref={stickyBarRef} data-sticky-bar className="pp-sticky-shell" style={{ top: 56 }}>
              <div className="pp-sticky-inner">
                {(() => {
                  const _jwt = localStorage.getItem('jwt_token');
                  const _param = localStorage.getItem('param_token');
                  const isLoggedOut = !_jwt && !_param;
                  if (isLoggedOut) {
                    const openTrack = () => { trackEvent('modal_open_track_property_public', { property_id: propertyId }); setShowTrackPublicModal(true); };
                    const benefits = [
                      'Get price move alerts',
                      'See new comparable sales & rentals',
                    ];
                    return (
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={openTrack}
                        onKeyDown={(e) => { if (e.key === 'Enter') openTrack(); }}
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 16,
                          padding: isMobile ? '8px 4px' : '14px 4px',
                          flexWrap: isMobile ? 'nowrap' : 'nowrap',
                        }}
                      >
                        {!isMobile && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                backgroundColor: `${accentColor}1a`, color: accentColor, fontSize: 20,
                              }}
                            >
                              <FaBell />
                            </div>
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <div style={{ fontWeight: 700, fontSize: 16, color: '#111', lineHeight: 1.2 }}>
                                Track this property
                              </div>
                              <div style={{ display: 'flex', gap: 18, marginTop: 4, flexWrap: 'wrap' }}>
                                {benefits.map((b, i) => (
                                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5, color: '#374151' }}>
                                    <FaCheckCircle size={13} color="#16a34a" />
                                    <span>{b}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                        <button
                          onClick={(e) => { e.stopPropagation(); openTrack(); }}
                          className="pp-sticky-review-btn"
                          style={{
                            color: buttonTextColor || '#fff',
                            borderColor: accentColor,
                            backgroundColor: accentColor,
                            fontWeight: 700,
                            flexShrink: 0,
                            padding: isMobile ? '10px 16px' : '11px 22px',
                            fontSize: isMobile ? 13.5 : 14,
                            whiteSpace: 'nowrap',
                            width: isMobile ? '100%' : 'auto',
                          }}
                        >
                          <FaBell size={isMobile ? 12 : 12} /> Track this property
                        </button>
                      </div>
                    );
                  }
                  return (
                <div className="pp-sticky-summary-row">
                    <div className="pp-sticky-agent-block">
                        {agentDetails?.agent_profile_image && (
                            <img src={agentDetails.agent_profile_image} alt={agentDetails.agent_name} className="pp-sticky-agent-image" />
                        )}
                        <div className="pp-sticky-agent-copy">
                            <div className="pp-sticky-agent-name">{agentDetails?.agent_name}</div>
                            {agentDetails?.agency_name_short && <div className="pp-sticky-agency">{agentDetails.agency_name_short}</div>}
                        </div>
                    </div>

                    <div className="pp-sticky-cta-row">
                        <Button
                            size="sm"
                            onClick={() => { trackEvent('click_edit_property_details'); setModalStep('edit'); setShowEditModal(true); }}
                            disabled={analysisLoading}
                            className="pp-sticky-edit-btn"
                        >
                            <FaPencilAlt size={10} /> Edit & Analyse
                        </Button>
                        <button
                            onClick={() => setShowRequestAppraisalModal(true)}
                            className="pp-sticky-review-btn"
                            style={{ color: accentColor, borderColor: `${accentColor}2e`, backgroundColor: `${accentColor}0d` }}
                        >
                            <FaEnvelope size={11} /> Request Review
                        </button>
                    </div>
                </div>
                  );
                })()}

                <div className="pp-sticky-tabs-row" ref={stickyTabsRowRef}>
                {[
                    { key: 'sale-estimate', label: 'Sale Estimate' },
                    { key: 'sale-comparables', label: 'Similar Sold' },
                    { key: 'sale-days', label: 'Days to Sell' },
                    { key: 'rent-estimate', label: 'Rent Estimate' },
                    { key: 'rent-comparables', label: 'Similar Rented' },
                    { key: 'rent-days', label: 'Days to Rent' },
                    { key: 'on-market', label: 'On The Market' },
                    { key: 'location', label: 'Location' },
                    { key: 'history', label: 'History' },
                ].filter(tab => isSectionVisible(tab.key)).map(tab => (
                    <button
                        key={tab.key}
                        ref={(el) => { stickyTabButtonRefs.current[tab.key] = el; }}
                        onClick={() => { trackEvent('click_tab', { tab: tab.key }); handleSectionClick(tab.key); }}
                        className="pp-sticky-tab-btn"
                        style={{
                            flex: '0 0 auto',
                            color: activeSection === tab.key ? accentColor : '#9ca3af',
                            borderBottom: activeSection === tab.key ? `2px solid ${accentColor}` : '2px solid transparent',
                        }}
                    >
                        {tab.label}
                    </button>
                ))}
              </div>
            </div>
            </div>
            {agentDetails && (  
            <SignInModal 
                show={modalShow} 
                onHide={() => { trackEvent('modal_close_sign_in'); setModalShow(false); }}
                onSuccess={handleModalSuccess}
                agentDetails={agentDetails}
            />
            )}
            {agentDetails && (
                <ValuationFeedbackModal
                    show={showValuationFeedbackModal}
                    onHide={() => setShowValuationFeedbackModal(false)}
                    agentDetails={agentDetails}
                    propertyId={propertyId}
                    propertySlug={property}
                    addressText={propertyData?.address_text || ''}
                    aiValuation={propertyAnalysisData?.valuation}
                    aiValuationLower={propertyAnalysisData?.valuation_lower}
                    aiValuationUpper={propertyAnalysisData?.valuation_upper}
                    onSaveSuccess={() => { try { fetchUserNotes(); } catch (_) {} }}
                    onRequireSignIn={() => { setShowValuationFeedbackModal(false); setModalShow(true); }}
                />
            )}
            {agentDetails && (
                <RequestAppraisalModal
                    show={showRequestAppraisalModal}
                    onHide={() => setShowRequestAppraisalModal(false)}
                    agentDetails={agentDetails}
                    propertyAddress={propertyData?.address_text || ''}
                    propertyDetails={{
                        bedrooms, bathrooms, carspaces, propertyType, landArea,
                        valuation: propertyAnalysisData?.valuation || null,
                        valuationLower: propertyAnalysisData?.valuation_lower || null,
                        valuationUpper: propertyAnalysisData?.valuation_upper || null,
                        rentalEstimate: propertyAnalysisData?.rental_estimate || null,
                        rentalEstimateLower: propertyAnalysisData?.rental_estimate_lower || null,
                        rentalEstimateUpper: propertyAnalysisData?.rental_estimate_upper || null,
                        daysToSell: propertyAnalysisData?.days_to_sell || null,
                        daysToSellLower: propertyAnalysisData?.days_to_sell_lower || null,
                        daysToSellUpper: propertyAnalysisData?.days_to_sell_upper || null,
                    }}
                />
            )}
            {agentDetails && (
                <EnquiryModal
                    show={showEnquiryFromBar}
                    onHide={() => setShowEnquiryFromBar(false)}
                    agentDetails={agentDetails}
                />
            )}
            {agentDetails && (
                <TrackPropertyModal
                    show={showTrackPublicModal}
                    onHide={() => setShowTrackPublicModal(false)}
                    agentDetails={agentDetails}
                    propertyId={propertyId}
                    propertyAddress={propertyData?.address_text || ''}
                    agentSlug={agent_slug}
                />
            )}
            {mediaUrls && (
            <div style={{ position: 'relative', width: '100%', height: isMobile ? 360 : 520, overflow: 'hidden', marginTop: isMobile ? 116 : 124 }}>
            <Carousel
                activeIndex={activeIndex}
                onSelect={handleSelect}
                controls={mediaUrls && mediaUrls.length > 1 && mediaUrls[0] !== null}
                indicators={mediaUrls && mediaUrls.length > 1 && mediaUrls[0] !== null}
                interval={5000}
                fade
            >
                {(mediaUrls && mediaUrls.length > 0 && mediaUrls[0] !== null ? mediaUrls : ['https://realestate-reports-assets.s3.us-west-2.amazonaws.com/static_assets/no-image.jpg']).map((url, index) => (
                    <Carousel.Item key={index}>
                        <img
                            src={url}
                            alt={`Property ${index + 1}`}
                            onError={e => { e.target.onerror = null; e.target.src = 'https://realestate-reports-assets.s3.us-west-2.amazonaws.com/static_assets/no-image.jpg'; }}
                            style={{
                                width: '100%',
                                height: isMobile ? 360 : 520,
                                objectFit: 'cover',
                                display: 'block',
                            }}
                        />
                    </Carousel.Item>
                ))}
            </Carousel>
            </div>
            )}
        <Container style={{ padding: '12px', maxWidth: '900px' }}>
            <div className="pp-header-card">
                <div className="pp-header-top">
                    <div className="pp-header-main">
                        <p className="pp-header-eyebrow">Property Profile</p>
                        <h1 className="pp-header-title">
                            {propertyData.flat_number ? `${propertyData.flat_number}/` : ''}{propertyData.street_number} {propertyData.street_name} {propertyData.street_type_long}
                        </h1>
                        <Link
                            to={agent_slug === "home-price" ? `/suburb-profile/${propertyData.suburb_id}` : `/suburb-profile/${propertyData.suburb_id}?agent=${agent_slug}`}
                            className="pp-header-location"
                        >
                            {propertyData.suburb} {propertyData.postcode}, {propertyData.state}
                            <FaExternalLinkAlt style={{ marginLeft: 6, fontSize: '0.72rem', color: iconColor }} />
                        </Link>
                        <div className="pp-header-meta">
                            {bedrooms !== null && bedrooms !== undefined && (
                                <span className="pp-header-meta-chip"><FaBed style={{ marginRight: 6, fontSize: '0.7rem' }} /> {bedrooms} bed</span>
                            )}
                            {bathrooms !== null && bathrooms !== undefined && (
                                <span className="pp-header-meta-chip"><FaBath style={{ marginRight: 6, fontSize: '0.7rem' }} /> {bathrooms} bath</span>
                            )}
                            {carspaces !== null && carspaces !== undefined && (
                                <span className="pp-header-meta-chip"><FaCar style={{ marginRight: 6, fontSize: '0.7rem' }} /> {carspaces} car</span>
                            )}
                            {landArea && (
                                <span className="pp-header-meta-chip"><FaRulerCombined style={{ marginRight: 6, fontSize: '0.7rem' }} /> {landArea} m²</span>
                            )}
                            {propertyTypeLabel && (
                                <span className="pp-header-meta-chip">{propertyTypeLabel}</span>
                            )}
                        </div>
                    </div>
                    <div className="pp-header-actions">
                    <Button 
                        variant="primary" 
                        onClick={handleTrackProperty} 
                        disabled={ isTogglingTrack}
                        className="pp-action-btn"
                        style={{ 
                            backgroundColor: isPropertyTracked ? '#fff' : accentColor, 
                            color: isPropertyTracked ? accentColor : buttonTextColor, 
                            borderColor: isPropertyTracked ? accentColor : (isLight ? '#222' : accentColor), 
                            borderRadius: '999px',
                            fontWeight: 600,
                            fontSize: '0.82rem',
                            lineHeight: 1.2,
                            padding: isMobile ? '9px 14px' : '8px 14px',
                            minHeight: '38px',
                            width: isMobile ? 'calc(50% - 4px)' : 'auto', 
                            marginBottom: 0,
                            boxShadow: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {isTogglingTrack ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{ marginRight: '6px' }}
                            />
                        ) : isPropertyTracked ? (
                            <FaBell style={{ marginRight: '6px', fontSize: '0.8rem' }} />
                        ) : (
                            <FaBellSlash style={{ marginRight: '6px', fontSize: '0.8rem' }} />
                        )}
                            
                        { isPropertyTracked ? <span>Tracking</span> : <span>Track Property</span> }
                    </Button>
                    <Button 
                        variant="light" 
                        onClick={handleShare} 
                        className="pp-action-btn"
                        style={{ 
                            width: isMobile ? 'calc(50% - 4px)' : 'auto', 
                            marginBottom: 0,
                            borderRadius: '999px',
                            fontWeight: 600,
                            fontSize: '0.82rem',
                            lineHeight: 1.2,
                            padding: isMobile ? '9px 14px' : '8px 14px',
                            minHeight: '38px',
                            backgroundColor: '#fff',
                            border: '1px solid #d1d5db',
                            color: '#374151',
                            boxShadow: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <FaShareAlt style={{ marginRight: '6px', fontSize: '0.8rem' }} /> Share
                    </Button>
                    {agentDetails && <ShareModal 
                        agentDetails={agentDetails} 
                        show={showShareModal} 
                        isSendingShare={isSendingShare}
                        onHide={handleHideShareModal} 
                        propertyId={propertyId}
                        propertySlug={property}
                        addressText={propertyData?.address_text || ''}
                        agentSlug={agent_slug}
                        userEmail={agentDetails?.user_email || ''}
                        onShareSuccess={() => {
                            setShowShareModal(false);
                            setTrackToastMessage('Property report shared successfully!');
                            setShowTrackToast(true);
                        }}
                        onShareError={(msg) => {
                            setTrackToastMessage(msg || 'Failed to share. Please try again.');
                            setShowTrackToast(true);
                        }}
                    />}
                    </div>
                </div>
            </div>
            <ToastContainer
                style={{
                    position: 'fixed',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 9998,
                    opacity: 1
                }}
                className={`p-3 ${isMobile ? 'toast-container-mobile' : 'toast-container-desktop'}`}
            >
                <Toast show={showSaveToast} onClose={() => setShowSaveToast(false)} style={{ opacity: 1 }} delay={5000} bg='light' autohide>
                    <Toast.Body style={{ textAlign: 'center' }}>
                    Valuation saved successfully. View your valuations in {' '}
                    <Link 
                        to={agent_slug === "home-price" ? "/notifications" : `/notifications?agent=${agent_slug}`}
                        style={{ fontWeight: 'bold', color: accentColor }}
                    >
                    My Properties.
                    </Link>
                    </Toast.Body>
                </Toast>
                <Toast show={showTrackToast} onClose={() => setShowTrackToast(false)} style={{ opacity: 1 }} delay={5000} bg='light' autohide>
                    <Toast.Body style={{ textAlign: 'center' }}>
                        {trackToastMessage}{' '}
                        {trackToastMessage !== 'Something went wrong. Please try again.' && (
                            <Link 
                                to={agent_slug === "home-price" ? "/notifications" : `/notifications?agent=${agent_slug}`}
                                style={{ fontWeight: 'bold', color: accentColor }}
                            >
                                View Tracked Properties
                            </Link>
                        )}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </Container>
            <Container style={{ maxWidth: '900px',  minHeight: '600px'}}>

            {/* ═══ SALE ESTIMATE SECTION ═══ */}
            {isSectionVisible('sale-estimate') && (
            <div ref={saleEstimateRef} data-section="sale-estimate" style={{ paddingTop: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    Sale Estimate
                    {recalcEstimate.sale && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, color: accentColor, letterSpacing: 'normal', textTransform: 'none', fontWeight: 500 }}>
                            <Spinner animation="border" size="sm" style={{ width: 11, height: 11, borderWidth: 2 }} /> Updating
                        </span>
                    )}
                </div>
                {propertyAnalysisData?.valuation != null && agentDetails ? (
                    <div style={{ opacity: recalcEstimate.sale ? 0.55 : 1, transition: 'opacity 0.2s', pointerEvents: recalcEstimate.sale ? 'none' : 'auto' }}>
                    {/* Agent contact prompt — placed above the estimates panel */}
                    {agentDetails && (
                        <div style={{ marginBottom: 14, padding: isMobile ? '16px 14px' : '18px 20px', background: '#fff', border: `1px solid ${isLight ? '#e5e7eb' : `${accentColor}26`}`, borderTop: `3px solid ${agentAccentColor}`, borderRadius: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                                {agentDetails.agent_profile_image && (
                                    <img src={agentDetails.agent_profile_image} alt={agentDetails.agent_name} style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: `2px solid ${accentColor}26` }} />
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600, marginBottom: 2 }}>Want a more accurate estimate?</div>
                                    <div style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-0.01em' }}>Speak with {agentFirstName}</div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                {agentPhone && (
                                    phoneRevealed.sale ? (
                                        <a
                                            href={`tel:${agentPhone}`}
                                            onClick={() => trackEvent('click_agent_phone', { phone: agentPhone, source: 'sale_estimate' })}
                                            style={btnPrimaryStyle}
                                        >
                                            <FaPhone size={12} /> {formatAgentPhone(agentPhone)}
                                        </a>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() => handleRevealAgentPhone('sale')}
                                            style={btnPrimaryStyle}
                                        >
                                            <FaPhone size={12} /> Call {agentFirstName}
                                        </button>
                                    )
                                )}
                                <button
                                    type="button"
                                    onClick={() => { trackEvent('open_enquiry_modal', { trigger: 'sale_estimate' }); setShowEnquiryFromBar(true); }}
                                    style={btnSecondaryStyle}
                                >
                                    <FaEnvelope size={12} /> Contact
                                </button>
                            </div>
                        </div>
                    )}
                    {/* Valuation feedback prompt — opens a modal so the homeowner
                        can submit a minimum acceptable price + justification note.
                        Saves to user_property_notes and emails the agent. */}
                    <button
                        type="button"
                        onClick={() => { trackEvent('open_valuation_feedback_modal', { property_id: propertyId }); setShowValuationFeedbackModal(true); }}
                        style={{
                            display: 'flex', alignItems: 'center', gap: 8,
                            background: '#fff7ed', border: '1px solid #fde68a',
                            borderRadius: 10, padding: '10px 14px',
                            marginTop: -4, marginBottom: 14, width: '100%',
                            cursor: 'pointer', textAlign: 'left',
                            fontSize: '0.85rem', color: '#92400e',
                            transition: 'background 0.15s, border-color 0.15s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#ffedd5'; e.currentTarget.style.borderColor = '#fcd34d'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = '#fff7ed'; e.currentTarget.style.borderColor = '#fde68a'; }}
                    >
                        <FaQuestionCircle style={{ color: '#f59e0b', flexShrink: 0, fontSize: '1rem' }} />
                        <span style={{ flex: 1, lineHeight: 1.4 }}>
                            <strong>Think this estimate is off?</strong> Tell {agentDetails?.agent_first_name || 'the agent'} what we missed and your minimum acceptable price.
                        </span>
                    </button>
                    <PropertyMetric
                        title="Valuation Estimate"
                        metric_definition="The estimated value of the property based on recent comparable sales data."
                        lowerValue={formatCurrency(propertyAnalysisData.valuation_lower)}
                        midValue={formatCurrency(propertyAnalysisData.valuation)}
                        upperValue={formatCurrency(propertyAnalysisData.valuation_upper)}
                        midColor={accentColor}
                        time_series_date={propertyAnalysisData.time_series?.reporting_month || []}
                        time_series_value={propertyAnalysisData.time_series?.valuation_estimate || []}
                        yxaxis_label={'Valuation Estimate ($)'}
                        is_currency={true}
                        percentChangeLastMonth={propertyAnalysisData.valuation_percent_change_last_month}
                        percentChangeYearAgo={propertyAnalysisData.valuation_percent_change_year_ago}
                        percentChange3YearsAgo={propertyAnalysisData.valuation_percent_change_3_years_ago}
                        percentChangeLastTransacted={propertyAnalysisData.valuation_percent_change_last_transacted}
                        estimateLastMonth={propertyAnalysisData.valuation_1_month}
                        estimateYearAgo={propertyAnalysisData.valuation_1_year}
                        estimate3YearsAgo={propertyAnalysisData.valuation_3_years}
                        lastTransactedValue={propertyData.sold_price}
                        lastTransactedDate={propertyData.sold_date}
                        lastTransactedLabel="Last Sold"
                        showTimeSeries={true}
                        footerSlot={(
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 16, padding: '10px 14px', background: '#f9fafb', border: '1px solid #f0f0f0', borderRadius: 10, fontSize: '0.8rem', color: '#6b7280', lineHeight: 1.5 }}>
                                <FaInfoCircle style={{ color: '#9ca3af', flexShrink: 0, marginTop: 2, fontSize: '0.85rem' }} />
                                <span style={{ flex: 1 }}>
                                    Based on <strong style={{ color: '#374151' }}>{comparableCards.filter(c => c.listing_type === 'Sold' && !excludedCompIds.has(c.id)).length} similar sold {comparableCards.filter(c => c.listing_type === 'Sold' && !excludedCompIds.has(c.id)).length === 1 ? 'property' : 'properties'}</strong> — the AI sometimes gets this wrong.{' '}
                                    <button type="button" onClick={() => handleRefineComparables('sale')} style={{ background: 'none', border: 'none', padding: 0, color: accentColor, fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}>
                                        Refine comparables
                                    </button> to get a custom estimate.
                                </span>
                            </div>
                        )}
                    />
                    </div>
                ) : (analysisLoading || streamingAiSummary || structuredLoading || selectingComparables) ? (
                    <div style={{ marginBottom: '2rem', padding: '1.25rem', border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder, borderRadius: 16, backgroundColor: '#fff', boxShadow: '0 2px 16px rgba(0,0,0,0.04)' }}>
                        <Skeleton width="45%" height={18} style={{ marginBottom: 6 }} />
                        <Skeleton width="80%" height={13} style={{ marginBottom: 20 }} />
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', textAlign: 'center', marginBottom: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={110} height={30} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                        </div>
                        <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
                            {[1,2,3,4].map(i => <div key={i} style={{ flex: 1 }}><Skeleton height={65} borderRadius={12} /></div>)}
                        </div>
                        <Skeleton height={160} borderRadius={12} />
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: isMobile ? '2.5rem 1rem' : '3rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: `1px solid ${panelBorderColor}`, borderTop: sectionTopBorder }}>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1rem', marginBottom: 6 }}>No estimate yet</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.5 }}>Run a property analysis to see your estimated sale price.</p>
                    </div>
                )}
            </div>
            )}

            {/* ═══ SALE COMPARABLES SECTION ═══ */}
            {isSectionVisible('sale-comparables') && (
            <div ref={saleComparablesRef} data-section="sale-comparables">
            <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                Similar Sold{comparableCards.filter(c => c.listing_type === 'Sold').length > 0 ? ` (${comparableCards.filter(c => c.listing_type === 'Sold').length})` : ''}
            </div>
            {comparableCards.filter(c => c.listing_type === 'Sold').length > 0 && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 7, marginBottom: 16, padding: '9px 12px', background: '#f9fafb', border: '1px solid #f0f0f0', borderRadius: 10, fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.45 }}>
                    <FaInfoCircle style={{ color: '#9ca3af', flexShrink: 0, marginTop: 2, fontSize: '0.8rem' }} />
                    <span><strong style={{ color: '#374151' }}>Exclude</strong> any sold property that isn't truly comparable to yours — the AI can't see what you know about your home, and removing them sharpens your estimate.</span>
                </div>
            )}

            <Modal style={{ zIndex: 9999 }} fullscreen={isMobile ? true : undefined} scrollable centered={!isMobile} size="lg" show={estimationInfoShowModal || showEditModal} onHide={handleCloseEditModal}>
                {modalStep === 'info' ? (
                <>
                <Modal.Body style={{ padding: isMobile ? '2rem 1.5rem' : '2.5rem 3rem 2rem', background: 'linear-gradient(180deg, #fafafa 0%, #fff 100%)' }}>
                    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                        <div style={{ width: 44, height: 44, borderRadius: '50%', background: `${accentColor}14`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
                            <FaHome style={{ color: accentColor, fontSize: '1.1rem' }} />
                        </div>
                        <h5 style={{ fontWeight: 700, fontSize: '1.15rem', color: '#111', marginBottom: 8 }}>Get Your Property Estimate</h5>
                        {propertyData?.address_text && (
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px', background: `${accentColor}10`, border: `1px solid ${accentColor}26`, borderRadius: 999, fontSize: '0.78rem', fontWeight: 600, color: '#374151', maxWidth: '100%' }}>
                                <FaMapMarkerAlt style={{ color: accentColor, flexShrink: 0, fontSize: '0.72rem' }} />
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{propertyData.address_text}</span>
                            </div>
                        )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: '0.5rem' }}>
                        {[
                            { icon: '1', text: 'Review property details — beds, baths, land area, type' },
                            { icon: '2', text: 'Click Get My Estimate' },
                            { icon: '3', text: 'AI finds similar sold & rented properties and shows how yours compares' },
                            { icon: '4', text: 'Exclude any sold or rented comparable you disagree with — your estimate updates instantly' },
                        ].map((step) => (
                            <div key={step.icon} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                                <div style={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: `${iconBgColor}14`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>
                                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: iconColor }}>{step.icon}</span>
                                </div>
                                <span style={{ fontSize: '0.85rem', color: '#374151', lineHeight: 1.5 }}>{step.text}</span>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: 'none', padding: '0 2rem 1.5rem', justifyContent: 'center' }}>
                    <Button
                        variant="primary"
                        onClick={() => {
                            const alreadySeen = sessionStorage.getItem('valuationToolModalSeen');
                            sessionStorage.setItem('valuationToolModalSeen', 'true');
                            trackEvent('analysis_started', { agent_slug, property_address: propertyData?.address_text || '' });
                            if (!alreadySeen) {
                                handleTokenAndPostRequest(
                                    `${window.api_host}/save-settings`,
                                    {
                                        agent_slug: agent_slug,
                                        event_type: 'onboarding_complete',
                                        metadata: {
                                            property_address: propertyData?.address_text || '',
                                        },
                                    },
                                    { 'Content-Type': 'application/json' }
                                ).catch(err => console.error('Error saving onboarding_complete event:', err));
                            }
                            setModalStep('edit');
                        }}
                        style={{
                            backgroundColor: accentColor,
                            borderColor: isLight ? '#222' : accentColor,
                            color: buttonTextColor,
                            borderRadius: 12,
                            fontWeight: 600,
                            fontSize: '0.9rem',
                            padding: '10px 32px',
                            width: '100%',
                        }}
                    >
                        Got it
                    </Button>
                </Modal.Footer>
                </>
                ) : null}
                {modalStep === 'edit' && agentDetails && propertyData ? (
                <>
                <Modal.Body className="pp-edit-modal-body" style={{ padding: isMobile ? '18px 14px' : '24px 26px' }}>
                    {/* Header row */}
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 14 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <h5 style={{ margin: 0, fontWeight: 800, fontSize: '1.25rem', color: '#111827', letterSpacing: '-0.02em', lineHeight: 1.3 }}>Confirm property details to get your estimate</h5>
                            {propertyData?.address_text && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 8, padding: '5px 10px', background: `${accentColor}10`, border: `1px solid ${accentColor}26`, borderRadius: 999, fontSize: '0.74rem', fontWeight: 600, color: '#374151', maxWidth: '100%' }}>
                                    <FaMapMarkerAlt style={{ color: accentColor, flexShrink: 0, fontSize: '0.68rem' }} />
                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{propertyData.address_text}</span>
                                </div>
                            )}
                        </div>
                        <button onClick={handleCloseEditModal} className="pp-edit-close-btn" onMouseEnter={e => e.currentTarget.style.color = '#374151'} onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}>
                            <FaTimes style={{ fontSize: '1.1rem' }} />
                        </button>
                    </div>

                    {/* Property specs — compact grid */}
                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(3, minmax(0, 1fr))' : 'repeat(5, minmax(0, 1fr))', gap: isMobile ? 8 : 10, marginBottom: 14, width: '100%' }}>
                        {[
                            { label: 'Bed', icon: <FaBed size={13} />, value: bedrooms, set: setBedrooms, event: 'change_bedrooms' },
                            { label: 'Bath', icon: <FaBath size={13} />, value: bathrooms, set: setBathrooms, event: 'change_bathrooms' },
                            { label: 'Car', icon: <FaCar size={13} />, value: carspaces, set: setCarspaces, event: 'change_carspaces' },
                        ].map(spec => (
                            <div key={spec.label} className="pp-edit-spec-card">
                                <span style={{ fontSize: '0.62rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#9ca3af', display: 'block', marginBottom: 6 }}>{spec.label}</span>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: isMobile ? 5 : 8, minWidth: 0 }}>
                                    <button onClick={() => { trackEvent(spec.event, { direction: 'decrease' }); spec.set(Math.max(0, parseInt(spec.value || 0) - 1)); }} disabled={analysisLoading} className="pp-edit-stepper-btn"><FaMinus size={8}/></button>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
                                        <span style={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a1a' }}>{spec.value ?? 0}</span>
                                        <span style={{ color: '#9ca3af' }}>{spec.icon}</span>
                                    </div>
                                    <button onClick={() => { trackEvent(spec.event, { direction: 'increase' }); spec.set(parseInt(spec.value || 0) + 1); }} disabled={analysisLoading} className="pp-edit-stepper-btn"><FaPlus size={8}/></button>
                                </div>
                            </div>
                        ))}
                        {/* Property Type */}
                        <div className="pp-edit-spec-card" style={{ gridColumn: isMobile ? 'span 2' : 'auto' }}>
                            <span style={{ fontSize: '0.62rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#9ca3af', display: 'block', marginBottom: 4 }}>Type</span>
                            { propertyType && (
                                <Select 
                                    options={propertyTypeOptions} 
                                    components={animatedComponents}
                                    closeMenuOnSelect={true}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 99999 }),
                                        control: (base, state) => ({ ...base, borderRadius: 8, borderColor: state.isFocused ? accentColor : '#e5e7eb', backgroundColor: '#fff', boxShadow: state.isFocused ? `0 0 0 2px ${accentColor}20` : 'none', minHeight: 32, fontSize: '0.78rem', '&:hover': { borderColor: accentColor } }),
                                        option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? accentColor : state.isFocused ? `${accentColor}08` : 'white', color: state.isSelected ? '#fff' : '#333', fontSize: '0.78rem', padding: '6px 10px' }),
                                        singleValue: (base) => ({ ...base, fontSize: '0.78rem', fontWeight: 600 }),
                                        indicatorSeparator: () => ({ display: 'none' }),
                                        dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
                                    }}
                                    onChange={e => { trackEvent('change_property_type', { value: e.value }); setPropertyType(e.value); }}
                                    value={propertyTypeOptions.find(option => option.value === propertyType)}
                                    isDisabled={analysisLoading}
                                />
                            )}    
                        </div>
                        {/* Land Area */}
                        <div className="pp-edit-spec-card">
                            <span style={{ fontSize: '0.62rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#9ca3af', display: 'block', marginBottom: 4 }}>Land m²</span>
                            <Form.Control 
                                type="number" value={landArea} onChange={(e) => setLandArea(e.target.value)}
                                onBlur={(e) => trackEvent('change_land_area', { value: e.target.value })}
                                placeholder="—" disabled={analysisLoading}
                                style={{ borderRadius: 8, border: '1px solid #e5e7eb', padding: '4px 8px', fontSize: '0.78rem', fontWeight: 600, backgroundColor: '#fff', boxShadow: 'none', textAlign: 'center' }}
                            />
                        </div>
                    </div>

                    {/* Collapsible description & image toggle — hidden on first session view */}
                    {!isFirstReviewView && (
                    <button type="button" onClick={() => setShowEditExtras(prev => !prev)}
                        style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 0', marginBottom: showEditExtras ? 10 : 0, color: '#6b7280', fontSize: '0.78rem', fontWeight: 600, textAlign: 'left', width: '100%' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#374151'} onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
                        <FaChevronRight style={{ fontSize: '0.55rem', flexShrink: 0, transition: 'transform 0.2s', transform: showEditExtras ? 'rotate(90deg)' : 'rotate(0deg)' }} />
                        Edit description & images for a more accurate estimate (optional)
                    </button>
                    )}

                    {!isFirstReviewView && showEditExtras && <>
                    {/* Notes section — collapsed */}
                    <div className="pp-edit-notes-wrap">
                        {agentNotes.length > 0 && (
                        <div style={{ display: 'flex', backgroundColor: '#f3f4f6', borderRadius: 8, padding: 2, marginBottom: 10 }}>
                            {['your-notes', 'agent-notes'].map((tab) => (
                                <button key={tab} type="button" onClick={() => setNotesTabKey(tab)}
                                    style={{ flex: 1, padding: '5px 0', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: '0.72rem', fontWeight: 600, transition: 'all 0.15s', backgroundColor: notesTabKey === tab ? '#fff' : 'transparent', color: notesTabKey === tab ? '#111' : '#9ca3af', boxShadow: notesTabKey === tab ? '0 1px 4px rgba(0,0,0,0.06)' : 'none' }}>
                                    {tab === 'your-notes' ? `Notes${userNotes.length > 0 ? ` (${userNotes.length})` : ''}` : `Agent${agentNotes.length > 0 ? ` (${agentNotes.length})` : ''}`}
                                </button>
                            ))}
                        </div>
                        )}
                        {(notesTabKey === 'your-notes' || agentNotes.length === 0) && (
                            <div>
                                <div style={{ position: 'relative' }}>
                                    <Form.Control ref={userNoteRef} as="textarea" rows={2} value={newUserNote} onChange={(e) => setNewUserNote(e.target.value)} disabled={isSavingUserNote || analysisLoading} placeholder="e.g. Recently renovated kitchen, north-facing backyard. More detail = more accurate estimate." className="notes-placeholder-light"
                                        style={{ width: '100%', overflow: 'hidden', resize: 'none', borderRadius: 8, border: '1px solid #e5e7eb', padding: '8px 10px', fontSize: '0.82rem', backgroundColor: '#fff', boxShadow: 'none' }} />
                                </div>
                                {userNotes.length > 0 && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 8 }}>
                                        {[...userNotes].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).slice(0, 3).map((item) => (
                                            <div key={item.id} style={{ backgroundColor: '#fff', borderRadius: 8, padding: '6px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <p style={{ marginBottom: 0, whiteSpace: 'pre-wrap', fontSize: '0.78rem', color: '#374151', lineHeight: 1.4 }}>{item.note}</p>
                                                    {item.created_at && <span style={{ fontSize: '0.62rem', color: '#c0c5cc', fontWeight: 400, letterSpacing: '0.01em' }}>{new Date(typeof item.created_at === 'number' && item.created_at < 1e12 ? item.created_at * 1000 : item.created_at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })} · {new Date(typeof item.created_at === 'number' && item.created_at < 1e12 ? item.created_at * 1000 : item.created_at).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit', hour12: true })}</span>}
                                                </div>
                                                <button type="button" onClick={() => handleDeleteUserNote(item.id)} disabled={deletingNoteId === item.id}
                                                    style={{ background: 'none', border: 'none', color: '#d1d5db', cursor: 'pointer', padding: 2, flexShrink: 0 }}
                                                    onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'} onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                                                    {deletingNoteId === item.id ? <Spinner animation="border" size="sm" style={{ width: 10, height: 10 }} /> : <FaTrash style={{ fontSize: '0.6rem' }} />}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                        {notesTabKey === 'agent-notes' && agentNotes.length > 0 && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                {[...agentNotes].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).slice(0, 3).map((item) => (
                                    <div key={item.id} style={{ backgroundColor: `${accentColor}06`, borderRadius: 8, padding: '6px 10px', border: `1px solid ${accentColor}12` }}>
                                        <p style={{ marginBottom: 0, whiteSpace: 'pre-wrap', fontSize: '0.78rem', color: '#374151', lineHeight: 1.4 }}>{item.note}</p>
                                        {item.created_at && <span style={{ fontSize: '0.62rem', color: '#c0c5cc', fontWeight: 400, letterSpacing: '0.01em' }}>{new Date(typeof item.created_at === 'number' && item.created_at < 1e12 ? item.created_at * 1000 : item.created_at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })} · {new Date(typeof item.created_at === 'number' && item.created_at < 1e12 ? item.created_at * 1000 : item.created_at).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit', hour12: true })}</span>}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Image upload */}
                    { uploadedImageUrls && (
                        <div className="pp-edit-upload-wrap">
                            <ImageUploadButton
                                agentDetails={agentDetails}
                                onUploadSuccess={handleUploadedUrls}
                                onDeleteSuccess={handleDeletedUrl}
                                onShowSignInModal={() => { trackEvent('modal_open_sign_in', { trigger: 'image_upload' }); setModalShow(true); }}
                                propertyId={propertyId}  
                                analysisLoading={analysisLoading}
                                uploadedImageUrls={uploadedImageUrls}                      
                            />
                        </div>
                    )}
                    </>}


                </Modal.Body>
                <Modal.Footer className="pp-edit-modal-footer" style={{ borderTop: '1px solid #eceff3', padding: isMobile ? '12px 14px' : '12px 26px', background: '#fafafa' }}>
                    <Button
                        onClick={() => { setShowEditModal(false); setEstimationInfoShowModal(false); handleAnalyseProperty(); }}
                        disabled={analysisLoading || !analysisNeeded}
                        style={{
                            background: analysisNeeded ? `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}dd 100%)` : '#e5e7eb',
                            border: 'none',
                            color: analysisNeeded ? buttonTextColor : '#9ca3af',
                            borderRadius: 12,
                            fontWeight: 700,
                            fontSize: '0.92rem',
                            padding: '12px 32px',
                            width: '100%',
                            boxShadow: analysisNeeded ? `0 4px 20px ${accentColor}35` : 'none',
                            transition: 'all 0.2s',
                            letterSpacing: '-0.01em',
                        }}
                    >
                                    {analysisLoading ? (
                                        <span>
                                            <Spinner animation="border" size="sm" style={{ marginRight: '5px' }}/> Loading...
                                        </span>
                                    ) : (
                                        !analysisNeeded ? (
                                            <span>
                                                <FaCheck style={{ marginRight: '5px' }} /> Analysis Complete
                                            </span>
                                        ) : (
                                            <span>
                                                <FaSearch style={{ marginRight: '5px' }} /> Get My Estimate
                                            </span>
                                        )
                                    )}
                                </Button>
                            </Modal.Footer>
                </>
                ) : null}
            </Modal>

                {analysisLoading && !isStreaming && !streamingAiSummary && !comparableCards.length ? (
                    <div ref={estimatesAreaRef} style={{ marginTop: '2rem' }}>
                        {/* Skeleton: comparable cards */}
                        <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', marginBottom: 28 }}>
                            {[1, 2, 3, 4].map(i => (
                                <div key={i} style={{ padding: isMobile ? '10px 12px' : '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: isMobile ? 10 : 14 }}>
                                    <Skeleton width={isMobile ? 52 : 64} height={isMobile ? 52 : 64} borderRadius={8} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton width="75%" height={12} />
                                        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                                            <Skeleton width={70} height={12} />
                                            <Skeleton width={80} height={10} />
                                        </div>
                                    </div>
                                    <Skeleton width={50} height={10} />
                                </div>
                            ))}
                        </div>
                        {/* Skeleton: estimate panel */}
                        <div style={{ backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: `1px solid ${panelBorderColor}`, borderTop: sectionTopBorder, padding: isMobile ? '24px 16px' : '32px 28px' }}>
                            <Skeleton width="45%" height={16} style={{ marginBottom: 6 }} />
                            <Skeleton width="80%" height={12} style={{ marginBottom: 18 }} />
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', textAlign: 'center', marginBottom: 16 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><Skeleton width={30} height={10} style={{ marginBottom: 4 }} /><Skeleton width={90} height={22} /></div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><Skeleton width={30} height={10} style={{ marginBottom: 4 }} /><Skeleton width={110} height={28} /></div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><Skeleton width={30} height={10} style={{ marginBottom: 4 }} /><Skeleton width={90} height={22} /></div>
                            </div>
                            <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
                                {[1,2,3,4].map(i => <div key={i} style={{ flex: 1 }}><Skeleton height={65} borderRadius={12} /></div>)}
                            </div>
                            <Skeleton height={160} borderRadius={12} />
                        </div>
                        {/* Loading step indicator */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, marginTop: 16 }}>
                            <Spinner animation="border" size="sm" style={{ color: iconColor }} />
                            <span style={{ fontSize: '0.85rem', color: '#9ca3af', fontWeight: 500 }}>
                                {selectingComparables ? 'Selecting best comparables...' : `${estimateSectionSteps[analysisStep]}...`}
                            </span>
                            <small style={{ color: '#c0c5cc', fontSize: '0.72rem' }}>
                                {selectingComparables ? 'Step 1 of 4' : `Step ${analysisStep + 1} of ${estimateSectionSteps.length}`}
                            </small>
                        </div>
                    </div>
                ) : !propertyAnalysisData && !streamingAiSummary && !isStreaming && !comparableCards.length ? (
                    <div style={{ textAlign: 'center', padding: isMobile ? '3rem 1rem' : '4rem 2rem', marginTop: '24px', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: `1px solid ${panelBorderColor}`, borderTop: sectionTopBorder }}>
                        <div style={{ width: 48, height: 48, borderRadius: 14, background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}cc 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem', boxShadow: `0 4px 16px ${accentColor}25` }}>
                            <FaSearch style={{ fontSize: '1.1rem', color: '#fff' }} />
                        </div>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1.05rem', marginBottom: 8 }}>Your valuation results will appear here</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.6 }}>Edit your property details and click <strong style={{ color: '#374151' }}>Analyse Property</strong> to generate a live valuation, rental estimate, and AI market summary.</p>
                    </div>
                ) : (
                    <div style={{ fontSize: isMobile ? '0.8rem' : 'initial', marginTop: '24px' }}>
                        {/* Sale Comparable Properties Cards */}
                        {comparableCards.filter(c => c.listing_type === 'Sold').length > 0 && (() => {
                            const allSoldComps = comparableCards.filter(c => c.listing_type === 'Sold');
                            const visibleSoldComps = showAllSaleComps ? allSoldComps : allSoldComps.slice(0, 4);
                            const remainingSold = allSoldComps.length - visibleSoldComps.length;
                            const soldMapData = allSoldComps.filter(c => c.latitude && c.longitude).map(c => ({
                                ...c,
                                display_address: c.address,
                                filter_date_label: 'Sold',
                                ai_analysis: comparableResults[c.id] ? { score: comparableResults[c.id].score } : undefined,
                            }));
                            return (
                            <div style={{ marginBottom: 28 }}>
                                {soldMapData.length > 0 && (
                                    <CompViewToggle view={soldCompView} onChange={setSoldCompView} accentColor={accentColor} buttonTextColor={buttonTextColor} />
                                )}
                                {soldCompView === 'map' && soldMapData.length > 0 ? (
                                    <div style={{ borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
                                        <AppraisalMap
                                            comparables={soldMapData}
                                            subjectProperty={{ latitude, longitude, display_address: propertyData?.address_text, photo_url_main: mediaUrls?.[0] || null, photo_urls: mediaUrls || [], bedrooms, bathrooms, carspaces, land_area: landArea, property_type_display: propertyType?.label || propertyType }}
                                            accentColor={accentColor}
                                            excludedIds={excludedCompIds}
                                            onToggleExclude={handleToggleExcludeComparable}
                                        />
                                    </div>
                                ) : (
                                <>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {visibleSoldComps.map(comp => {
                                        const result = comparableResults[comp.id];
                                        const isLoading = comparableLoading[comp.id];
                                        const parsedLandArea = (() => {
                                            if (comp.land_area == null) return null;
                                            if (typeof comp.land_area === 'number') return comp.land_area;
                                            if (typeof comp.land_area === 'object') return comp.land_area.size || null;
                                            try { const p = JSON.parse(comp.land_area); return typeof p === 'number' ? p : p?.size || null; } catch { return parseFloat(comp.land_area) || null; }
                                        })();
                                        const dateStr = (() => {
                                            const raw = comp.filter_date || comp.sold_timestamp;
                                            if (!raw) return null;
                                            const d = new Date(raw);
                                            if (isNaN(d)) return null;
                                            return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
                                        })();
                                        const daysAgo = (() => {
                                            const raw = comp.filter_date || comp.sold_timestamp;
                                            if (!raw) return null;
                                            const d = new Date(raw);
                                            if (isNaN(d)) return null;
                                            return Math.round((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
                                        })();
                                        const dateLabel = comp.listing_type === 'Rent' || comp.listing_type === 'Leased' ? 'Leased' : 'Sold';
                                        const scoreLabels = ['', 'Low', 'Fair', 'Good', 'Strong', 'Excellent'];
                                        const scoreColors = ['', '#ef4444', '#f59e0b', '#22c55e', '#10b981', '#059669'];
                                        const scoreBgColors = ['', '#fef2f2', '#fffbeb', '#f0fdf4', '#ecfdf5', '#ecfdf5'];
                                        const s = result?.score != null ? Math.max(1, Math.min(5, Math.round(result.score))) : null;
                                        const diff = result?.diff;
                                        const loc = result?.location;
                                        const advStyles = { better: { color: '#dc2626', label: 'Better location' }, worse: { color: '#16a34a', label: 'Your property better' }, similar: { color: '#6b7280', label: 'Similar location' } };
                                        const isExpanded = expandedCompId === comp.id;
                                        const isExcluded = excludedCompIds.has(comp.id);
                                        const includedSoldCount = comparableCards.filter(c => c.listing_type === 'Sold' && !excludedCompIds.has(c.id)).length;
                                        const disableExclude = !isExcluded && includedSoldCount <= 1;

                                        return (
                                            <div key={comp.id} onClick={() => { const willExpand = !isExpanded; setExpandedCompId(willExpand ? comp.id : null); if (willExpand) handleAnalyseComparable(comp); }}
                                                onMouseEnter={e => { e.currentTarget.style.background = '#f9fafb'; }}
                                                onMouseLeave={e => { e.currentTarget.style.background = isExcluded ? '#fafafa' : '#fff'; }}
                                                style={{ background: isExcluded ? '#fafafa' : '#fff', borderBottom: '1px solid #f0f0f0', cursor: 'pointer', transition: 'background 0.15s' }}>
                                                {/* Compact row */}
                                                <div style={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? 10 : 14, padding: isMobile ? '10px 12px' : '12px 16px' }}>
                                                    {comp.photo_url_main && (
                                                        <img src={comp.photo_url_main} alt="" loading="lazy" style={{ width: isMobile ? 52 : 64, height: isMobile ? 52 : 64, borderRadius: 8, objectFit: 'cover', flexShrink: 0, opacity: isExcluded ? 0.4 : 1, filter: isExcluded ? 'grayscale(1)' : 'none' }} onError={e => { e.target.style.display = 'none'; }} />
                                                    )}
                                                    <div style={{ flex: 1, minWidth: 0, opacity: isExcluded ? 0.5 : 1, textDecoration: isExcluded ? 'line-through' : 'none' }}>
                                                        <div style={{ fontWeight: 600, fontSize: isMobile ? '0.82rem' : '0.88rem', color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', ...(isMobile ? { whiteSpace: 'normal', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' } : { whiteSpace: 'nowrap' }) }}>{comp.address}</div>
                                                        {isMobile ? (
                                                            <>
                                                                {comp.display_price && <div style={{ fontWeight: 700, fontSize: '0.82rem', color: accentColor, marginTop: 2 }}>{comp.display_price}</div>}
                                                                <div style={{ fontSize: '0.7rem', color: '#9ca3af', marginTop: 1 }}>
                                                                    {[comp.bedrooms != null && `${comp.bedrooms}bd`, comp.bathrooms != null && `${comp.bathrooms}ba`, comp.carspaces != null && `${comp.carspaces}car`, parsedLandArea != null && parsedLandArea > 0 && `${parsedLandArea}m²`].filter(Boolean).join(' · ')}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
                                                                {comp.display_price && <span style={{ fontWeight: 700, fontSize: '0.88rem', color: accentColor }}>{comp.display_price}</span>}
                                                                <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                                                                    {[comp.bedrooms != null && `${comp.bedrooms}bd`, comp.bathrooms != null && `${comp.bathrooms}ba`, comp.carspaces != null && `${comp.carspaces}car`, parsedLandArea != null && parsedLandArea > 0 && `${parsedLandArea}m²`].filter(Boolean).join(' · ')}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {dateStr && <div style={{ fontSize: isMobile ? '0.68rem' : '0.72rem', color: '#9ca3af', marginTop: 2 }}>{dateLabel} {dateStr}{!isMobile && daysAgo != null ? ` · ${daysAgo}d ago` : ''}</div>}
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
                                                        {isLoading ? (
                                                            <Spinner animation="border" size="sm" style={{ width: 14, height: 14, borderWidth: 2, color: '#9ca3af' }} />
                                                        ) : s != null ? (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                                <div style={{ display: 'flex', gap: 1 }}>{[1,2,3,4,5].map(i => <FaStar key={i} size={isMobile ? 8 : 10} style={{ color: i <= s ? scoreColors[s] : '#e5e7eb' }} />)}</div>
                                                                <span style={{ fontSize: '0.65rem', fontWeight: 600, color: scoreColors[s] }}>{scoreLabels[s]}</span>
                                                            </div>
                                                        ) : result && !isLoading ? (
                                                            <FaCheck size={12} style={{ color: '#22c55e' }} />
                                                        ) : null}
                                                        <span style={{ fontSize: '0.68rem', color: accentColor, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 3 }}>
                                                            {isMobile ? 'View' : 'View Comparison'} <FaChevronRight size={8} style={{ transition: 'transform 0.2s', transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }} />
                                                        </span>
                                                        <button
                                                            type="button"
                                                            onClick={(e) => { e.stopPropagation(); if (!disableExclude) handleToggleExcludeComparable(comp); }}
                                                            disabled={disableExclude}
                                                            title={disableExclude ? 'Keep at least one comparable' : isExcluded ? 'Include in estimate' : 'Exclude from estimate'}
                                                            style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'none', border: 'none', padding: 0, fontSize: '0.68rem', fontWeight: 500, cursor: disableExclude ? 'not-allowed' : 'pointer', opacity: disableExclude ? 0.4 : 1, color: isExcluded ? '#16a34a' : '#9ca3af' }}>
                                                            {isExcluded ? <><FaUndo size={9} /> Include</> : <><FaBan size={9} /> Exclude</>}
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* Expanded detail */}
                                                {isExpanded && (
                                                    <div style={{ padding: isMobile ? '0 12px 14px' : '0 16px 18px' }}>
                                                        <ComparableImageCarousel
                                                            images={(comp.photo_urls && comp.photo_urls.length > 0) ? comp.photo_urls : [comp.photo_url_main].filter(Boolean)}
                                                            alt={comp.address}
                                                            isMobile={isMobile}
                                                        />
                                                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: '0.78rem', color: '#9ca3af', marginBottom: 8 }}>
                                                            {comp.bedrooms != null && <span><FaBed size={11} style={{ marginRight: 3 }} />{comp.bedrooms}</span>}
                                                            {comp.bathrooms != null && <span><FaBath size={11} style={{ marginRight: 3 }} />{comp.bathrooms}</span>}
                                                            {comp.carspaces != null && <span><FaCar size={11} style={{ marginRight: 3 }} />{comp.carspaces}</span>}
                                                            {parsedLandArea != null && parsedLandArea > 0 && <span><FaRulerCombined size={10} style={{ marginRight: 3 }} />{parsedLandArea}m²</span>}
                                                            {dateStr && <span><FaCalendarAlt size={10} style={{ marginRight: 3 }} />{dateLabel} {dateStr}{daysAgo != null ? ` (${daysAgo}d ago)` : ''}</span>}
                                                        </div>
                                                        {diff && (
                                                            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 8 }}>
                                                                {diff.bedrooms != null && (() => { const v = diff.bedrooms; const isZ = v === 0; const isP = v > 0; const c = isZ ? '#6b7280' : isP ? '#16a34a' : '#dc2626'; const bg = isZ ? '#f3f4f6' : isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isZ ? <FaMinus size={6}/> : isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {isZ ? 'Same beds' : `${isP?'+':''}${v} beds`}</span>; })()}
                                                                {diff.bathrooms != null && (() => { const v = diff.bathrooms; const isZ = v === 0; const isP = v > 0; const c = isZ ? '#6b7280' : isP ? '#16a34a' : '#dc2626'; const bg = isZ ? '#f3f4f6' : isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isZ ? <FaMinus size={6}/> : isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {isZ ? 'Same baths' : `${isP?'+':''}${v} baths`}</span>; })()}
                                                                {diff.parking != null && (() => { const v = diff.parking; const isZ = v === 0; const isP = v > 0; const c = isZ ? '#6b7280' : isP ? '#16a34a' : '#dc2626'; const bg = isZ ? '#f3f4f6' : isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isZ ? <FaMinus size={6}/> : isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {isZ ? 'Same parking' : `${isP?'+':''}${v} parking`}</span>; })()}
                                                                {diff.land_size != null && diff.land_size !== 0 && (() => { const v = diff.land_size; const isP = v > 0; const c = isP ? '#16a34a' : '#dc2626'; const bg = isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {`${isP?'+':''}${v}m² land`}</span>; })()}
                                                            </div>
                                                        )}
                                                        {result?.summary && <p style={{ fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.55, margin: '0 0 8px', borderTop: '1px solid #f3f4f6', paddingTop: 8 }}>{result.summary}</p>}
                                                        {loc && (
                                                            <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 10 }}>
                                                                {loc.map_url && <img src={loc.map_url} alt="Location comparison" loading="lazy" style={{ width: '100%', height: isMobile ? 120 : 180, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />}
                                                                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 6 }}>
                                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                                        {loc.relative_position && <div style={{ fontSize: '0.78rem', color: '#374151', fontWeight: 500, lineHeight: 1.4, marginBottom: 2 }}>{loc.relative_position}</div>}
                                                                        {loc.location_note && <div style={{ fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.4 }}>{loc.location_note}</div>}
                                                                    </div>
                                                                    <span style={{ fontSize: '0.65rem', fontWeight: 600, color: (advStyles[loc.location_advantage] || advStyles.similar).color, whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                                        {(advStyles[loc.location_advantage] || advStyles.similar).label}
                                                                    </span>
                                                                </div>
                                                                {loc.proximity_comparison?.length > 0 && (
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}>
                                                                        {loc.proximity_comparison.map((pc, idx) => (
                                                                            <div key={idx} style={{ backgroundColor: '#f9fafb', borderRadius: 8, padding: '6px 8px', borderLeft: `3px solid ${pc.closer === 'subject' ? '#16a34a' : pc.closer === 'comparable' ? '#6b7280' : '#e5e7eb'}` }}>
                                                                                <div style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '0.72rem', marginBottom: 2 }}>{pc.landmark}</div>
                                                                                <div style={{ display: 'flex', gap: 6, fontSize: '0.68rem' }}>
                                                                                    <span style={{ color: pc.closer === 'subject' ? '#16a34a' : '#6b7280', fontWeight: 500 }}>You: {pc.subject_distance}</span>
                                                                                    <span style={{ color: '#d1d5db' }}>|</span>
                                                                                    <span style={{ color: pc.closer === 'comparable' ? '#16a34a' : '#6b7280', fontWeight: 500 }}>Comp: {pc.comparable_distance}</span>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {isLoading && (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                                                                <Spinner animation="border" size="sm" style={{ color: '#6b7280' }} />
                                                                <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>Analysing...</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                {(remainingSold > 0 || (showAllSaleComps && allSoldComps.length > 4)) && (
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 14 }}>
                                        {remainingSold > 0 ? (
                                            <button
                                                type="button"
                                                onClick={() => { trackEvent('expand_sale_comparables', { remaining: remainingSold }); setShowAllSaleComps(true); }}
                                                style={btnPillSecondaryStyle}
                                                onMouseEnter={e => { e.currentTarget.style.background = `${accentColor}0a`; e.currentTarget.style.borderColor = accentColor; }}
                                                onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = `${accentColor}40`; }}
                                            >
                                                See {remainingSold} more <FaChevronRight size={9} />
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={() => { trackEvent('collapse_sale_comparables'); setShowAllSaleComps(false); }}
                                                style={{ padding: '8px 16px', background: 'transparent', border: 'none', color: '#6b7280', fontSize: '0.78rem', fontWeight: 500, cursor: 'pointer' }}
                                            >
                                                Show less
                                            </button>
                                        )}
                                    </div>
                                )}
                                </>
                                )}
                            </div>
                            );
                        })()}

                    </div>
                )}
            </div>
            )}

            {/* ═══ SALE DAYS SECTION ═══ */}
            {isSectionVisible('sale-days') && (
            <div ref={saleDaysRef} data-section="sale-days" style={{ paddingTop: '2rem' }}>
                <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    Sale Days on Market
                </div>
                {propertyAnalysisData?.days_to_sell != null && agentDetails ? (
                    <PropertyMetric
                        title="Days to Sell Estimate"
                        metric_definition="The estimated number of days it would take to sell the property based on recent comparable sales data."
                        lowerValue={propertyAnalysisData.days_to_sell_lower}
                        midValue={propertyAnalysisData.days_to_sell}
                        upperValue={propertyAnalysisData.days_to_sell_upper}
                        midColor={accentColor}
                        time_series_date={propertyAnalysisData.days_on_market_time_series?.reporting_month || []}
                        time_series_value={propertyAnalysisData.days_on_market_time_series?.median_sold_days_on_market || []}
                        yxaxis_label={'Days to Sell'}
                        is_currency={false}
                        showTimeSeries={true}
                        showComparisonCards={false}
                    />
                ) : (analysisLoading || streamingAiSummary || structuredLoading || selectingComparables) ? (
                    <div style={{ marginBottom: '2rem', padding: '1.25rem', border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder, borderRadius: 16, backgroundColor: '#fff', boxShadow: '0 2px 16px rgba(0,0,0,0.04)' }}>
                        <Skeleton width="45%" height={18} style={{ marginBottom: 6 }} />
                        <Skeleton width="80%" height={13} style={{ marginBottom: 20 }} />
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', textAlign: 'center', marginBottom: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={110} height={30} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                        </div>
                        <Skeleton height={160} borderRadius={12} />
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: isMobile ? '2.5rem 1rem' : '3rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1rem', marginBottom: 6 }}>No estimate yet</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.5 }}>Run a property analysis to see how long it might take to sell.</p>
                    </div>
                )}
            </div>
            )}

            {/* ═══ RENT ESTIMATE SECTION ═══ */}
            {isSectionVisible('rent-estimate') && (
            <div ref={rentEstimateRef} data-section="rent-estimate" style={{ paddingTop: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    Rent Estimate
                    {recalcEstimate.rent && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, color: accentColor, letterSpacing: 'normal', textTransform: 'none', fontWeight: 500 }}>
                            <Spinner animation="border" size="sm" style={{ width: 11, height: 11, borderWidth: 2 }} /> Updating
                        </span>
                    )}
                </div>
                {propertyAnalysisData?.rental_estimate != null && agentDetails ? (
                    <div style={{ opacity: recalcEstimate.rent ? 0.55 : 1, transition: 'opacity 0.2s', pointerEvents: recalcEstimate.rent ? 'none' : 'auto' }}>
                    {/* Agent contact prompt — placed above the estimates panel */}
                    {agentDetails && (
                        <div style={{ marginBottom: 14, padding: isMobile ? '16px 14px' : '18px 20px', background: '#fff', border: `1px solid ${isLight ? '#e5e7eb' : `${accentColor}26`}`, borderTop: `3px solid ${agentAccentColor}`, borderRadius: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                                {agentDetails.agent_profile_image && (
                                    <img src={agentDetails.agent_profile_image} alt={agentDetails.agent_name} style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: `2px solid ${accentColor}26` }} />
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600, marginBottom: 2 }}>Want a more accurate estimate?</div>
                                    <div style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-0.01em' }}>Speak with {agentFirstName}</div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                {agentPhone && (
                                    phoneRevealed.rent ? (
                                        <a
                                            href={`tel:${agentPhone}`}
                                            onClick={() => trackEvent('click_agent_phone', { phone: agentPhone, source: 'rent_estimate' })}
                                            style={btnPrimaryStyle}
                                        >
                                            <FaPhone size={12} /> {formatAgentPhone(agentPhone)}
                                        </a>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() => handleRevealAgentPhone('rent')}
                                            style={btnPrimaryStyle}
                                        >
                                            <FaPhone size={12} /> Call {agentFirstName}
                                        </button>
                                    )
                                )}
                                <button
                                    type="button"
                                    onClick={() => { trackEvent('open_enquiry_modal', { trigger: 'rent_estimate' }); setShowEnquiryFromBar(true); }}
                                    style={btnSecondaryStyle}
                                >
                                    <FaEnvelope size={12} /> Contact
                                </button>
                            </div>
                        </div>
                    )}
                    <PropertyMetric
                        title="Rental Estimate"
                        metric_definition="The estimated weekly rental income for the property based on recent comparable rental data."
                        lowerValue={formatCurrency(propertyAnalysisData.rental_estimate_lower)}
                        midValue={formatCurrency(propertyAnalysisData.rental_estimate)}
                        upperValue={formatCurrency(propertyAnalysisData.rental_estimate_upper)}
                        midColor={accentColor}
                        time_series_date={propertyAnalysisData.time_series?.reporting_month || []}
                        time_series_value={propertyAnalysisData.time_series?.rental_estimate || []}
                        yxaxis_label={'Rental Estimate ($)'}
                        is_currency={true}
                        percentChangeLastMonth={propertyAnalysisData.rental_estimate_percent_change_last_month}
                        percentChangeYearAgo={propertyAnalysisData.rental_estimate_percent_change_year_ago}
                        percentChange3YearsAgo={propertyAnalysisData.rental_estimate_percent_change_3_years_ago}
                        percentChangeLastTransacted={propertyAnalysisData.rental_estimate_percent_change_last_transacted}
                        estimateLastMonth={propertyAnalysisData.rental_estimate_1_month}
                        estimateYearAgo={propertyAnalysisData.rental_estimate_1_year}
                        estimate3YearsAgo={propertyAnalysisData.rental_estimate_3_years}
                        lastTransactedValue={propertyData.rented_price}
                        lastTransactedDate={propertyData.rented_date}
                        lastTransactedLabel="Last Rented"
                        showTimeSeries={true}
                        footerSlot={(
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 16, padding: '10px 14px', background: '#f9fafb', border: '1px solid #f0f0f0', borderRadius: 10, fontSize: '0.8rem', color: '#6b7280', lineHeight: 1.5 }}>
                                <FaInfoCircle style={{ color: '#9ca3af', flexShrink: 0, marginTop: 2, fontSize: '0.85rem' }} />
                                <span style={{ flex: 1 }}>
                                    Based on <strong style={{ color: '#374151' }}>{comparableCards.filter(c => c.listing_type !== 'Sold' && !excludedCompIds.has(c.id)).length} similar rented {comparableCards.filter(c => c.listing_type !== 'Sold' && !excludedCompIds.has(c.id)).length === 1 ? 'property' : 'properties'}</strong> — the AI sometimes gets this wrong.{' '}
                                    <button type="button" onClick={() => handleRefineComparables('rent')} style={{ background: 'none', border: 'none', padding: 0, color: accentColor, fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}>
                                        Refine comparables
                                    </button> to get a custom estimate.
                                </span>
                            </div>
                        )}
                    />
                    </div>
                ) : (analysisLoading || streamingAiSummary || structuredLoading || selectingComparables) ? (
                    <div style={{ marginBottom: '2rem', padding: '1.25rem', border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder, borderRadius: 16, backgroundColor: '#fff', boxShadow: '0 2px 16px rgba(0,0,0,0.04)' }}>
                        <Skeleton width="45%" height={18} style={{ marginBottom: 6 }} />
                        <Skeleton width="80%" height={13} style={{ marginBottom: 20 }} />
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', textAlign: 'center', marginBottom: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={110} height={30} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                        </div>
                        <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
                            {[1,2,3,4].map(i => <div key={i} style={{ flex: 1 }}><Skeleton height={65} borderRadius={12} /></div>)}
                        </div>
                        <Skeleton height={160} borderRadius={12} />
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: isMobile ? '2.5rem 1rem' : '3rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: `1px solid ${panelBorderColor}`, borderTop: sectionTopBorder }}>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1rem', marginBottom: 6 }}>No estimate yet</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.5 }}>Run a property analysis to see your estimated rental income.</p>
                    </div>
                )}
            </div>
            )}

            {/* ═══ RENT COMPARABLES SECTION ═══ */}
            {isSectionVisible('rent-comparables') && (
            <div ref={rentComparablesRef} data-section="rent-comparables" style={{ paddingTop: '2rem' }}>
                <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    Similar Rented{comparableCards.filter(c => c.listing_type !== 'Sold').length > 0 ? ` (${comparableCards.filter(c => c.listing_type !== 'Sold').length})` : ''}
                </div>
                {comparableCards.filter(c => c.listing_type !== 'Sold').length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 7, marginBottom: 16, padding: '9px 12px', background: '#f9fafb', border: '1px solid #f0f0f0', borderRadius: 10, fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.45 }}>
                        <FaInfoCircle style={{ color: '#9ca3af', flexShrink: 0, marginTop: 2, fontSize: '0.8rem' }} />
                        <span><strong style={{ color: '#374151' }}>Exclude</strong> any rented property that isn't truly comparable to yours — the AI can't see what you know about your home, and removing them sharpens your estimate.</span>
                    </div>
                )}
                {comparableCards.filter(c => c.listing_type !== 'Sold').length > 0 ? (() => {
                    const allRentComps = comparableCards.filter(c => c.listing_type !== 'Sold');
                    const visibleRentComps = showAllRentComps ? allRentComps : allRentComps.slice(0, 4);
                    const remainingRent = allRentComps.length - visibleRentComps.length;
                    const rentMapData = allRentComps.filter(c => c.latitude && c.longitude).map(c => ({
                        ...c,
                        display_address: c.address,
                        filter_date_label: 'Rented',
                        ai_analysis: comparableResults[c.id] ? { score: comparableResults[c.id].score } : undefined,
                    }));
                    return (
                    <div style={{ marginBottom: 28 }}>
                        {rentMapData.length > 0 && (
                            <CompViewToggle view={rentCompView} onChange={setRentCompView} accentColor={accentColor} buttonTextColor={buttonTextColor} />
                        )}
                        {rentCompView === 'map' && rentMapData.length > 0 ? (
                            <div style={{ borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
                                <AppraisalMap
                                    comparables={rentMapData}
                                    subjectProperty={{ latitude, longitude, display_address: propertyData?.address_text, photo_url_main: mediaUrls?.[0] || null, photo_urls: mediaUrls || [], bedrooms, bathrooms, carspaces, land_area: landArea, property_type_display: propertyType?.label || propertyType }}
                                    accentColor={accentColor}
                                    excludedIds={excludedCompIds}
                                    onToggleExclude={handleToggleExcludeComparable}
                                />
                            </div>
                        ) : (
                        <>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {visibleRentComps.map(comp => {
                                const result = comparableResults[comp.id];
                                const isLoading = comparableLoading[comp.id];
                                const parsedLandArea = (() => { if (comp.land_area == null) return null; if (typeof comp.land_area === 'number') return comp.land_area; if (typeof comp.land_area === 'object') return comp.land_area.size || null; try { const p = JSON.parse(comp.land_area); return typeof p === 'number' ? p : p?.size || null; } catch { return parseFloat(comp.land_area) || null; } })();
                                const dateStr = (() => { const raw = comp.filter_date || comp.sold_timestamp; if (!raw) return null; const d = new Date(raw); if (isNaN(d)) return null; return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }); })();
                                const daysAgo = (() => { const raw = comp.filter_date || comp.sold_timestamp; if (!raw) return null; const d = new Date(raw); if (isNaN(d)) return null; return Math.round((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24)); })();
                                const dateLabel = comp.listing_type === 'Sold' ? 'Sold' : 'Rented';
                                const s = result?.score != null ? Math.round(result.score) : null;
                                const diff = result?.diff;
                                const loc = result?.location;
                                const scoreColors = { 1: '#ef4444', 2: '#f97316', 3: '#eab308', 4: '#22c55e', 5: '#16a34a' };
                                const scoreBgColors = { 1: '#fef2f2', 2: '#fff7ed', 3: '#fefce8', 4: '#f0fdf4', 5: '#f0fdf4' };
                                const scoreLabels = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Strong', 5: 'Excellent' };
                                const advStyles = { better: { color: '#dc2626', label: 'Comp better location' }, worse: { color: '#16a34a', label: 'Your better location' }, similar: { color: '#6b7280', label: 'Similar location' } };
                                const isExpanded = expandedCompId === comp.id;
                                const isExcluded = excludedCompIds.has(comp.id);
                                const includedRentCount = comparableCards.filter(c => c.listing_type !== 'Sold' && !excludedCompIds.has(c.id)).length;
                                const disableExclude = !isExcluded && includedRentCount <= 1;

                                return (
                                    <div key={comp.id} onClick={() => { const willExpand = !isExpanded; setExpandedCompId(willExpand ? comp.id : null); if (willExpand) handleAnalyseComparable(comp); }}
                                        onMouseEnter={e => { e.currentTarget.style.background = '#f9fafb'; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = isExcluded ? '#fafafa' : '#fff'; }}
                                        style={{ background: isExcluded ? '#fafafa' : '#fff', borderBottom: '1px solid #f0f0f0', cursor: 'pointer', transition: 'background 0.15s' }}>
                                        {/* Compact row */}
                                        <div style={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? 10 : 14, padding: isMobile ? '10px 12px' : '12px 16px' }}>
                                            {comp.photo_url_main && (
                                                <img src={comp.photo_url_main} alt="" loading="lazy" style={{ width: isMobile ? 52 : 64, height: isMobile ? 52 : 64, borderRadius: 8, objectFit: 'cover', flexShrink: 0, opacity: isExcluded ? 0.4 : 1, filter: isExcluded ? 'grayscale(1)' : 'none' }} onError={e => { e.target.style.display = 'none'; }} />
                                            )}
                                            <div style={{ flex: 1, minWidth: 0, opacity: isExcluded ? 0.5 : 1, textDecoration: isExcluded ? 'line-through' : 'none' }}>
                                                <div style={{ fontWeight: 600, fontSize: isMobile ? '0.82rem' : '0.88rem', color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', ...(isMobile ? { whiteSpace: 'normal', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' } : { whiteSpace: 'nowrap' }) }}>{comp.address}</div>
                                                {isMobile ? (
                                                    <>
                                                        {comp.display_price && <div style={{ fontWeight: 700, fontSize: '0.82rem', color: accentColor, marginTop: 2 }}>{comp.display_price}</div>}
                                                        <div style={{ fontSize: '0.7rem', color: '#9ca3af', marginTop: 1 }}>
                                                            {[comp.bedrooms != null && `${comp.bedrooms}bd`, comp.bathrooms != null && `${comp.bathrooms}ba`, comp.carspaces != null && `${comp.carspaces}car`, parsedLandArea != null && parsedLandArea > 0 && `${parsedLandArea}m²`].filter(Boolean).join(' · ')}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
                                                        {comp.display_price && <span style={{ fontWeight: 700, fontSize: '0.88rem', color: accentColor }}>{comp.display_price}</span>}
                                                        <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                                                            {[comp.bedrooms != null && `${comp.bedrooms}bd`, comp.bathrooms != null && `${comp.bathrooms}ba`, comp.carspaces != null && `${comp.carspaces}car`, parsedLandArea != null && parsedLandArea > 0 && `${parsedLandArea}m²`].filter(Boolean).join(' · ')}
                                                        </span>
                                                    </div>
                                                )}
                                                {dateStr && <div style={{ fontSize: isMobile ? '0.68rem' : '0.72rem', color: '#9ca3af', marginTop: 2 }}>{dateLabel} {dateStr}{!isMobile && daysAgo != null ? ` · ${daysAgo}d ago` : ''}</div>}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
                                                {isLoading ? (
                                                    <Spinner animation="border" size="sm" style={{ width: 14, height: 14, borderWidth: 2, color: '#9ca3af' }} />
                                                ) : s != null ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                        <div style={{ display: 'flex', gap: 1 }}>{[1,2,3,4,5].map(i => <FaStar key={i} size={isMobile ? 8 : 10} style={{ color: i <= s ? scoreColors[s] : '#e5e7eb' }} />)}</div>
                                                        <span style={{ fontSize: '0.65rem', fontWeight: 600, color: scoreColors[s] }}>{scoreLabels[s]}</span>
                                                    </div>
                                                ) : result && !isLoading ? (
                                                    <FaCheck size={12} style={{ color: '#22c55e' }} />
                                                ) : null}
                                                <span style={{ fontSize: '0.68rem', color: accentColor, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 3 }}>
                                                    {isMobile ? 'View' : 'View Comparison'} <FaChevronRight size={8} style={{ transition: 'transform 0.2s', transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }} />
                                                </span>
                                                <button
                                                    type="button"
                                                    onClick={(e) => { e.stopPropagation(); if (!disableExclude) handleToggleExcludeComparable(comp); }}
                                                    disabled={disableExclude}
                                                    title={disableExclude ? 'Keep at least one comparable' : isExcluded ? 'Include in estimate' : 'Exclude from estimate'}
                                                    style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'none', border: 'none', padding: 0, fontSize: '0.68rem', fontWeight: 500, cursor: disableExclude ? 'not-allowed' : 'pointer', opacity: disableExclude ? 0.4 : 1, color: isExcluded ? '#16a34a' : '#9ca3af' }}>
                                                    {isExcluded ? <><FaUndo size={9} /> Include</> : <><FaBan size={9} /> Exclude</>}
                                                </button>
                                            </div>
                                        </div>
                                        {/* Expanded detail */}
                                        {isExpanded && (
                                            <div style={{ padding: isMobile ? '0 12px 14px' : '0 16px 18px' }}>
                                                <ComparableImageCarousel
                                                    images={(comp.photo_urls && comp.photo_urls.length > 0) ? comp.photo_urls : [comp.photo_url_main].filter(Boolean)}
                                                    alt={comp.address}
                                                    isMobile={isMobile}
                                                />
                                                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: '0.78rem', color: '#9ca3af', marginBottom: 8 }}>
                                                    {comp.bedrooms != null && <span><FaBed size={11} style={{ marginRight: 3 }} />{comp.bedrooms}</span>}
                                                    {comp.bathrooms != null && <span><FaBath size={11} style={{ marginRight: 3 }} />{comp.bathrooms}</span>}
                                                    {comp.carspaces != null && <span><FaCar size={11} style={{ marginRight: 3 }} />{comp.carspaces}</span>}
                                                    {parsedLandArea != null && parsedLandArea > 0 && <span><FaRulerCombined size={10} style={{ marginRight: 3 }} />{parsedLandArea}m²</span>}
                                                    {dateStr && <span><FaCalendarAlt size={10} style={{ marginRight: 3 }} />{dateLabel} {dateStr}{daysAgo != null ? ` (${daysAgo}d ago)` : ''}</span>}
                                                </div>
                                                {diff && (
                                                    <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 8 }}>
                                                        {diff.bedrooms != null && (() => { const v = diff.bedrooms; const isZ = v === 0; const isP = v > 0; const c = isZ ? '#6b7280' : isP ? '#16a34a' : '#dc2626'; const bg = isZ ? '#f3f4f6' : isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isZ ? <FaMinus size={6}/> : isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {isZ ? 'Same beds' : `${isP?'+':''}${v} beds`}</span>; })()}
                                                        {diff.bathrooms != null && (() => { const v = diff.bathrooms; const isZ = v === 0; const isP = v > 0; const c = isZ ? '#6b7280' : isP ? '#16a34a' : '#dc2626'; const bg = isZ ? '#f3f4f6' : isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isZ ? <FaMinus size={6}/> : isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {isZ ? 'Same baths' : `${isP?'+':''}${v} baths`}</span>; })()}
                                                        {diff.parking != null && (() => { const v = diff.parking; const isZ = v === 0; const isP = v > 0; const c = isZ ? '#6b7280' : isP ? '#16a34a' : '#dc2626'; const bg = isZ ? '#f3f4f6' : isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isZ ? <FaMinus size={6}/> : isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {isZ ? 'Same parking' : `${isP?'+':''}${v} parking`}</span>; })()}
                                                        {diff.land_size != null && diff.land_size !== 0 && (() => { const v = diff.land_size; const isP = v > 0; const c = isP ? '#16a34a' : '#dc2626'; const bg = isP ? '#f0fdf4' : '#fef2f2'; return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.68rem', fontWeight: 500, color: c, backgroundColor: bg, padding: '2px 8px', borderRadius: 10 }}>{isP ? <FaArrowUp size={6}/> : <FaArrowDown size={6}/>} {`${isP?'+':''}${v}m² land`}</span>; })()}
                                                    </div>
                                                )}
                                                {result?.summary && <p style={{ fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.55, margin: '0 0 8px', borderTop: '1px solid #f3f4f6', paddingTop: 8 }}>{result.summary}</p>}
                                                {loc && (
                                                    <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 10 }}>
                                                        {loc.map_url && <img src={loc.map_url} alt="Location comparison" loading="lazy" style={{ width: '100%', height: isMobile ? 120 : 180, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />}
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 6 }}>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                {loc.relative_position && <div style={{ fontSize: '0.78rem', color: '#374151', fontWeight: 500, lineHeight: 1.4, marginBottom: 2 }}>{loc.relative_position}</div>}
                                                                {loc.location_note && <div style={{ fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.4 }}>{loc.location_note}</div>}
                                                            </div>
                                                            <span style={{ fontSize: '0.65rem', fontWeight: 600, color: (advStyles[loc.location_advantage] || advStyles.similar).color, whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                                {(advStyles[loc.location_advantage] || advStyles.similar).label}
                                                            </span>
                                                        </div>
                                                        {loc.proximity_comparison?.length > 0 && (
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}>
                                                                {loc.proximity_comparison.map((pc, idx) => (
                                                                    <div key={idx} style={{ backgroundColor: '#f9fafb', borderRadius: 8, padding: '6px 8px', borderLeft: `3px solid ${pc.closer === 'subject' ? '#16a34a' : pc.closer === 'comparable' ? '#6b7280' : '#e5e7eb'}` }}>
                                                                        <div style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '0.72rem', marginBottom: 2 }}>{pc.landmark}</div>
                                                                        <div style={{ display: 'flex', gap: 6, fontSize: '0.68rem' }}>
                                                                            <span style={{ color: pc.closer === 'subject' ? '#16a34a' : '#6b7280', fontWeight: 500 }}>You: {pc.subject_distance}</span>
                                                                            <span style={{ color: '#d1d5db' }}>|</span>
                                                                            <span style={{ color: pc.closer === 'comparable' ? '#16a34a' : '#6b7280', fontWeight: 500 }}>Comp: {pc.comparable_distance}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {isLoading && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                                                        <Spinner animation="border" size="sm" style={{ color: '#6b7280' }} />
                                                        <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>Analysing...</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                        {(remainingRent > 0 || (showAllRentComps && allRentComps.length > 4)) && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 14 }}>
                                {remainingRent > 0 ? (
                                    <button
                                        type="button"
                                        onClick={() => { trackEvent('expand_rent_comparables', { remaining: remainingRent }); setShowAllRentComps(true); }}
                                        style={{ padding: '10px 20px', background: '#fff', border: `1px solid ${accentColor}40`, color: accentColor, borderRadius: 999, fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, boxShadow: '0 1px 2px rgba(0,0,0,0.04)', transition: 'background 0.15s, border-color 0.15s' }}
                                        onMouseEnter={e => { e.currentTarget.style.background = `${accentColor}0a`; e.currentTarget.style.borderColor = accentColor; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = `${accentColor}40`; }}
                                    >
                                        See {remainingRent} more <FaChevronRight size={9} />
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => { trackEvent('collapse_rent_comparables'); setShowAllRentComps(false); }}
                                        style={{ padding: '8px 16px', background: 'transparent', border: 'none', color: '#6b7280', fontSize: '0.78rem', fontWeight: 500, cursor: 'pointer' }}
                                    >
                                        Show less
                                    </button>
                                )}
                            </div>
                        )}
                        </>
                        )}
                    </div>
                    );
                })() : (analysisLoading || selectingComparables) ? (
                    <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
                        {[1,2,3].map(i => (
                            <div key={i} style={{ padding: isMobile ? '10px 12px' : '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: isMobile ? 10 : 14 }}>
                                <Skeleton width={isMobile ? 52 : 64} height={isMobile ? 52 : 64} borderRadius={8} />
                                <div style={{ flex: 1 }}>
                                    <Skeleton width="75%" height={12} />
                                    <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                                        <Skeleton width={70} height={12} />
                                        <Skeleton width={80} height={10} />
                                    </div>
                                </div>
                                <Skeleton width={50} height={10} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: isMobile ? '2.5rem 1rem' : '3rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1rem', marginBottom: 6 }}>No similar rented properties yet</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.5 }}>Run a property analysis to see similar rented properties.</p>
                    </div>
                )}
            </div>
            )}

            {/* ═══ RENT DAYS SECTION ═══ */}
            {isSectionVisible('rent-days') && (
            <div ref={rentDaysRef} data-section="rent-days" style={{ paddingTop: '2rem' }}>
                <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    Rent Days on Market
                </div>
                {propertyAnalysisData?.days_to_lease != null && agentDetails ? (
                    <PropertyMetric
                        title="Days to Rent Estimate"
                        metric_definition="The estimated number of days it would take to rent the property based on recent comparable rental data."
                        lowerValue={propertyAnalysisData.days_to_lease_lower}
                        midValue={propertyAnalysisData.days_to_lease}
                        upperValue={propertyAnalysisData.days_to_lease_upper}
                        midColor={accentColor}
                        time_series_date={propertyAnalysisData.days_on_market_time_series?.reporting_month || []}
                        time_series_value={propertyAnalysisData.days_on_market_time_series?.median_rent_days_on_market || []}
                        yxaxis_label={'Days to Rent'}
                        is_currency={false}
                        showTimeSeries={true}
                        showComparisonCards={false}
                    />
                ) : (analysisLoading || streamingAiSummary || structuredLoading || selectingComparables) ? (
                    <div style={{ marginBottom: '2rem', padding: '1.25rem', border: `1px solid ${tileBorderColor}`, borderTop: sectionTopBorder, borderRadius: 16, backgroundColor: '#fff', boxShadow: '0 2px 16px rgba(0,0,0,0.04)' }}>
                        <Skeleton width="45%" height={18} style={{ marginBottom: 6 }} />
                        <Skeleton width="80%" height={13} style={{ marginBottom: 20 }} />
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', textAlign: 'center', marginBottom: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={110} height={30} /></div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}><Skeleton width={30} height={10} /><Skeleton width={90} height={24} /></div>
                        </div>
                        <Skeleton height={160} borderRadius={12} />
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: isMobile ? '2.5rem 1rem' : '3rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1rem', marginBottom: 6 }}>No estimate yet</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.5 }}>Run a property analysis to see how long it might take to rent.</p>
                    </div>
                )}
            </div>
            )}

            {/* ═══ ON THE MARKET SECTION ═══ */}
            {isSectionVisible('on-market') && (
            <div ref={onMarketRef} data-section="on-market" style={{ paddingTop: '2rem' }}>
                <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    On The Market Now{onMarketListings.length > 0 ? ` (${onMarketListings.length})` : ''}
                </div>
                <p style={{ fontSize: '0.82rem', color: '#6b7280', lineHeight: 1.5, margin: '0 0 16px' }}>
                    Properties currently listed for sale near {propertyData?.address_text ? 'this home' : 'this property'}, nearest first.
                </p>
                {onMarketLoading ? (
                    <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
                        {[1, 2, 3].map(i => (
                            <div key={i} style={{ padding: isMobile ? '10px 12px' : '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: isMobile ? 10 : 14 }}>
                                <Skeleton width={isMobile ? 52 : 64} height={isMobile ? 52 : 64} borderRadius={8} />
                                <div style={{ flex: 1 }}>
                                    <Skeleton width="75%" height={12} />
                                    <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                                        <Skeleton width={70} height={12} />
                                        <Skeleton width={80} height={10} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : onMarketListings.length > 0 ? (() => {
                    // Same map/pin/card design as the Similar Sold & Rented
                    // sections. Both views read the already-loaded listings, so
                    // flipping the toggle never refetches.
                    const onMarketMapData = onMarketListings.filter(c => c.latitude && c.longitude).map(c => ({
                        ...c,
                        filter_date_label: 'For Sale',
                    }));
                    return (
                    <>
                        {onMarketMapData.length > 0 && (
                            <CompViewToggle view={onMarketView} onChange={setOnMarketView} accentColor={accentColor} buttonTextColor={buttonTextColor} />
                        )}
                        {onMarketView === 'map' && onMarketMapData.length > 0 ? (
                            <div style={{ borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
                                <AppraisalMap
                                    comparables={onMarketMapData}
                                    subjectProperty={{ latitude, longitude, display_address: propertyData?.address_text, photo_url_main: mediaUrls?.[0] || null, photo_urls: mediaUrls || [], bedrooms, bathrooms, carspaces, land_area: landArea, property_type_display: propertyType?.label || propertyType }}
                                    accentColor={accentColor}
                                />
                            </div>
                        ) : (
                        <>
                        <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                            {(showAllOnMarket ? onMarketListings : onMarketListings.slice(0, 4)).map((listing, idx) => {
                                const addr = listing.display_address_short
                                    ? `${listing.display_address_short}${listing.suburb ? `, ${listing.suburb}` : ''}${listing.postcode ? ` ${listing.postcode}` : ''}`
                                    : (listing.display_address || '');
                                const specs = [
                                    listing.bedrooms != null && `${listing.bedrooms}bd`,
                                    listing.bathrooms != null && `${listing.bathrooms}ba`,
                                    listing.carspaces != null && `${listing.carspaces}car`,
                                    listing.land_area != null && listing.land_area > 0 && `${listing.land_area}m²`,
                                ].filter(Boolean).join(' · ');
                                const meta = [
                                    listing.distance_km != null && `${listing.distance_km}km away`,
                                    listing.days_on_market != null && `${listing.days_on_market} days on market`,
                                ].filter(Boolean).join(' · ');
                                return (
                                    <div key={listing.id || idx} style={{ borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? 10 : 14, padding: isMobile ? '10px 12px' : '12px 16px' }}>
                                        {listing.photo_url_main && (
                                            <img src={listing.photo_url_main} alt="" loading="lazy" style={{ width: isMobile ? 52 : 64, height: isMobile ? 52 : 64, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} onError={e => { e.target.style.display = 'none'; }} />
                                        )}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ fontWeight: 600, fontSize: isMobile ? '0.82rem' : '0.88rem', color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', ...(isMobile ? { whiteSpace: 'normal', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' } : { whiteSpace: 'nowrap' }) }}>{addr}</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2, flexWrap: 'wrap' }}>
                                                {listing.display_price && <span style={{ fontWeight: 700, fontSize: isMobile ? '0.82rem' : '0.88rem', color: accentColor }}>{listing.display_price}</span>}
                                                {specs && <span style={{ fontSize: isMobile ? '0.7rem' : '0.75rem', color: '#9ca3af' }}>{specs}</span>}
                                            </div>
                                            {meta && <div style={{ fontSize: isMobile ? '0.68rem' : '0.72rem', color: '#9ca3af', marginTop: 2 }}>{meta}</div>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {onMarketListings.length > 4 && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 14 }}>
                                <button
                                    type="button"
                                    onClick={() => { trackEvent(showAllOnMarket ? 'collapse_on_market' : 'expand_on_market', { count: onMarketListings.length }); setShowAllOnMarket(v => !v); }}
                                    style={{ padding: showAllOnMarket ? '8px 16px' : '10px 20px', background: showAllOnMarket ? 'transparent' : '#fff', border: showAllOnMarket ? 'none' : `1px solid ${accentColor}40`, color: showAllOnMarket ? '#6b7280' : accentColor, borderRadius: 999, fontSize: showAllOnMarket ? '0.78rem' : '0.82rem', fontWeight: showAllOnMarket ? 500 : 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}
                                >
                                    {showAllOnMarket ? 'Show less' : <>See {onMarketListings.length - 4} more <FaChevronRight size={9} /></>}
                                </button>
                            </div>
                        )}
                        </>
                        )}
                    </>
                    );
                })() : (
                    <div style={{ textAlign: 'center', padding: isMobile ? '2.5rem 1rem' : '3rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1rem', marginBottom: 6 }}>Nothing on the market right now</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.5 }}>There are no similar properties currently listed for sale nearby.</p>
                    </div>
                )}
            </div>
            )}

            {/* ═══ LOCATION SECTION ═══ */}
            {isSectionVisible('location') && (
            <div ref={locationRef} data-section="location" style={{ paddingTop: '2rem' }}>
                <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    Location
                </div>
                {(!locationAnalysis && !locationLoading) && (
                    <div style={{ textAlign: 'center', padding: isMobile ? '3rem 1rem' : '4rem 2rem', backgroundColor: '#fff', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                        <div style={{ width: 48, height: 48, borderRadius: 14, background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}cc 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem', boxShadow: `0 4px 16px ${accentColor}25` }}>
                            <FaMapMarkerAlt style={{ fontSize: '1.1rem', color: '#fff' }} />
                        </div>
                        <h5 style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '1.05rem', marginBottom: 8 }}>Location Analysis</h5>
                        <p style={{ color: '#9ca3af', marginBottom: 0, fontSize: '0.85rem', lineHeight: 1.6 }}>
                            {comparableCards.length > 0
                                ? 'Location analysis will run automatically after your property analysis completes.'
                                : 'Run a property analysis first to generate a location report.'}
                        </p>
                    </div>
                )}
                {locationLoading && (
                    <div style={{ borderRadius: 20, overflow: 'hidden', backgroundColor: '#fff', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder }}>
                        {/* Summary skeleton */}
                        <div style={{ padding: isMobile ? '24px 20px' : '32px 32px 28px' }}>
                            <Skeleton count={3} style={{ marginBottom: 6 }} />
                            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                                <Skeleton width={120} height={32} borderRadius={20} />
                                <Skeleton width={140} height={32} borderRadius={20} />
                            </div>
                        </div>
                        {/* Positives & Negatives skeleton */}
                        <div style={{ borderTop: '1px solid #f0eeeb', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>
                            <div style={{ padding: isMobile ? '20px 20px' : '24px 32px', borderRight: isMobile ? 'none' : '1px solid #f0eeeb' }}>
                                <Skeleton width={80} height={10} style={{ marginBottom: 14 }} />
                                {[1,2,3].map(i => <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}><Skeleton circle width={16} height={16} /><Skeleton width="85%" height={12} /></div>)}
                            </div>
                            <div style={{ padding: isMobile ? '20px 20px' : '24px 32px', borderTop: isMobile ? '1px solid #f0eeeb' : 'none' }}>
                                <Skeleton width={100} height={10} style={{ marginBottom: 14 }} />
                                {[1,2].map(i => <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}><Skeleton circle width={16} height={16} /><Skeleton width="85%" height={12} /></div>)}
                            </div>
                        </div>
                        {/* Amenities skeleton */}
                        <div style={{ borderTop: '1px solid #f0eeeb', padding: isMobile ? '20px 20px' : '24px 32px' }}>
                            <Skeleton width={120} height={10} style={{ marginBottom: 16 }} />
                            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 10 }}>
                                {[1,2,3,4].map(i => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, backgroundColor: '#f9fafb', borderRadius: 14, padding: '12px 16px' }}>
                                        <Skeleton circle width={34} height={34} />
                                        <div style={{ flex: 1 }}><Skeleton width="60%" height={12} /><Skeleton width="40%" height={10} style={{ marginTop: 4 }} /></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* Value Factors skeleton */}
                        <div style={{ borderTop: '1px solid #f0eeeb', padding: isMobile ? '20px 20px' : '24px 32px' }}>
                            <Skeleton width={100} height={10} style={{ marginBottom: 16 }} />
                            {[1,2,3].map(i => (
                                <div key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', backgroundColor: '#f9fafb', borderRadius: 14, padding: '14px 18px', marginBottom: 12 }}>
                                    <Skeleton circle width={26} height={26} />
                                    <div style={{ flex: 1 }}><Skeleton width="45%" height={13} /><Skeleton width="80%" height={11} style={{ marginTop: 4 }} /></div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {locationAnalysis && (() => {
                    const la = locationAnalysis;
                    const amenityIcon = (type) => {
                        switch (type) {
                            case 'school': return <FaSchool size={12} />;
                            case 'shopping': return <FaShoppingCart size={12} />;
                            case 'park': return <FaTree size={12} />;
                            default: return <FaMapMarkerAlt size={12} />;
                        }
                    };
                    const impactStyles = {
                        positive: { color: '#16a34a', bg: '#f0fdf4', icon: <FaArrowUp size={9} /> },
                        negative: { color: '#dc2626', bg: '#fef2f2', icon: <FaArrowDown size={9} /> },
                        neutral: { color: '#6b7280', bg: '#f3f4f6', icon: <FaMinus size={9} /> },
                    };
                    const advantageStyles = {
                        better: { color: '#dc2626', label: 'Comparable has better location' },
                        worse: { color: '#16a34a', label: 'Your property has better location' },
                        similar: { color: '#6b7280', label: 'Similar location' },
                    };
                    return (
                        <div>
                            <div style={{
                                borderRadius: 20, overflow: 'hidden', backgroundColor: '#fff',
                                boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
                                borderTop: sectionTopBorder, marginBottom: 24,
                            }}>
                                {/* Summary + street info */}
                                <div style={{ padding: isMobile ? '24px 20px' : '32px 32px 28px' }}>
                                    {la.summary && (
                                        <p style={{ fontSize: '0.95rem', color: '#374151', lineHeight: 1.75, margin: '0 0 20px' }}>{la.summary}</p>
                                    )}
                                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                        {la.street_type && (
                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, backgroundColor: '#f5f3f0', padding: '6px 14px', borderRadius: 20, fontSize: '0.78rem', fontWeight: 600, color: '#1a1a1a' }}>
                                                <FaRoute size={11} style={{ color: accentColor }} /> {la.street_type}
                                            </span>
                                        )}
                                        {la.neighbourhood_type && (
                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, backgroundColor: '#f5f3f0', padding: '6px 14px', borderRadius: 20, fontSize: '0.78rem', fontWeight: 600, color: '#1a1a1a' }}>
                                                <FaHome size={11} style={{ color: accentColor }} /> {la.neighbourhood_type}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {/* Positives & Negatives */}
                                {(la.positives?.length > 0 || la.negatives?.length > 0) && (
                                    <div style={{ borderTop: '1px solid #f0eeeb', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>
                                        {la.positives?.length > 0 && (
                                            <div style={{ padding: isMobile ? '20px 20px' : '24px 32px', borderRight: isMobile ? 'none' : '1px solid #f0eeeb' }}>
                                                <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 600, color: '#16a34a', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <FaThumbsUp size={11} /> Positives
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                                    {la.positives.map((p, i) => (
                                                        <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: '0.85rem', color: '#374151', lineHeight: 1.5 }}>
                                                            <FaCheck size={10} style={{ color: '#16a34a', marginTop: 4, flexShrink: 0 }} /> {p}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        {la.negatives?.length > 0 && (
                                            <div style={{ padding: isMobile ? '20px 20px' : '24px 32px', borderTop: isMobile ? '1px solid #f0eeeb' : 'none' }}>
                                                <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 600, color: '#dc2626', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <FaExclamationTriangle size={11} /> Considerations
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                                    {la.negatives.map((n, i) => (
                                                        <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: '0.85rem', color: '#374151', lineHeight: 1.5 }}>
                                                            <FaMinus size={9} style={{ color: '#dc2626', marginTop: 5, flexShrink: 0 }} /> {n}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {/* Nearby Amenities */}
                                {la.nearby_amenities?.length > 0 && (
                                    <div style={{ borderTop: '1px solid #f0eeeb', padding: isMobile ? '20px 20px' : '24px 32px' }}>
                                        <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 600, color: '#9ca3af', marginBottom: 16 }}>Nearby Amenities</div>
                                        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 10 }}>
                                            {la.nearby_amenities.map((a, i) => (
                                                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, backgroundColor: '#f9fafb', borderRadius: 14, padding: '12px 16px' }}>
                                                    <div style={{ width: 34, height: 34, borderRadius: '50%', backgroundColor: '#f0eeeb', display: 'flex', alignItems: 'center', justifyContent: 'center', color: accentColor, flexShrink: 0 }}>
                                                        {amenityIcon(a.type)}
                                                    </div>
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1a1a1a', lineHeight: 1.3 }}>{a.name}</div>
                                                        <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: 2 }}>{a.distance_label}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {/* Value Factors */}
                                {la.value_factors?.length > 0 && (
                                    <div style={{ borderTop: '1px solid #f0eeeb', padding: isMobile ? '20px 20px' : '24px 32px' }}>
                                        <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 600, color: '#9ca3af', marginBottom: 16 }}>Value Factors</div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                            {la.value_factors.map((vf, i) => {
                                                const is = impactStyles[vf.impact] || impactStyles.neutral;
                                                return (
                                                    <div key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', backgroundColor: is.bg, borderRadius: 14, padding: '14px 18px' }}>
                                                        <div style={{ width: 26, height: 26, borderRadius: '50%', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1, color: is.color }}>{is.icon}</div>
                                                        <div style={{ flex: 1, minWidth: 0 }}>
                                                            <div style={{ fontWeight: 600, fontSize: '0.88rem', color: '#1a1a1a', marginBottom: 3 }}>{vf.factor}</div>
                                                            <div style={{ fontSize: '0.82rem', color: '#6b7280', lineHeight: 1.6 }}>{vf.detail}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })()}
            </div>
            )}

            {/* ═══ HISTORY SECTION ═══ */}
            {isSectionVisible('history') && (
            <div ref={historyRef} data-section="history" style={{ paddingTop: '2rem' }}>
                <div style={{ fontSize: '0.72rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 600, marginBottom: 16, borderLeft: `3px solid ${agentAccentColor}`, paddingLeft: 12 }}>
                    History
                </div>
                {propertyData && propertyData.history ? (
                    propertyData.history.length > 0 ? (
                    <>
                    <div style={{ marginBottom: '2rem', padding: isMobile ? '24px 20px' : '32px 32px 28px', borderRadius: 20, backgroundColor: '#fff', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', borderTop: sectionTopBorder, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                        <ul className="timeline" style={{ borderLeftColor: accentColor }}>
                            {propertyData.history.map((event, index) => (
                            <li key={index} className="timeline-item mb-5" style={{ '--dot-color': accentColor }}>
                                <span className="timeline-icon" style={{ backgroundColor: accentColor }}>
                                    
                                </span>
                                <span className="badge" style={{ marginBottom: '10px', backgroundColor: accentColor, color: buttonTextColor, borderRadius: '50px', padding: '5px 12px', fontWeight: 600, fontSize: '0.75rem', letterSpacing: '0.03em'}}>
                                    {event.type}
                                </span>                                                        
                                <h5 className="fw-bold" style={{ fontSize: '1.1rem' }}>
                                {event.price !== null && event.price !== 0 ? (<span> ${event.price.toLocaleString()}</span>): null}
                                {event.price !== null && event.price !== 0 ? (<span style={{ fontSize: '0.75rem', color: '#888', fontWeight: 400 }}> {event.label}</span>): (<span style={{ fontSize: '0.75rem', color: '#888', fontWeight: 400 }}> PRICE UNKNOWN </span>)}
                                </h5>
                                <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                    {event.date !== null ? new Date(event.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Unknown Date'}
                                </p>
                                <p className="text-muted"></p>
                            </li>
                            ))}
                        </ul>
                    </div>
                    </>
                    ) : (
                        <p style={{ color: '#888', fontSize: '0.9rem', textAlign: 'center', padding: '2rem' }}>No history available.</p>
                    )
                ) : null}
            </div>
            )}
            </Container>
            {showToast && (
                <div style={{
                    position: 'fixed',
                    bottom: isMobile ? 'calc(72px + env(safe-area-inset-bottom))' : 24,
                    left: 0,
                    right: 0,
                    zIndex: 1011,
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0 12px',
                }}>
                    <div style={{
                        backgroundColor: '#fffbeb',
                        color: '#92400e',
                        padding: '8px 16px',
                        borderRadius: '10px',
                        fontSize: '0.8rem',
                        fontWeight: 400,
                        textAlign: 'center',
                        maxWidth: '600px',
                        width: '100%',
                        border: '1px solid #fde68a',
                    }}>
                        <FaInfoCircle style={{ marginRight: '6px', marginBottom: '1px', fontSize: '0.75rem' }} />
                        Click <b>Analyse Property</b> to update your results.
                    </div>
                </div>
            )}
        </div>
        
    )
};

export default PropertyProfile;